import React from 'react';
import { saveAs } from 'file-saver';
// import XLSX from 'XLSX';
import Workbook from '../tools/Workbook.js';
import {
  SCORE_SHEET_NAME,
  AI_SCORE_SHEET_NAME,
  MARKS_SHEET_NAME,
  readPaperScorePartsFromSubmissionRow,
  computePaperScorePartsFromHotspotList,
  formatPaperScore,
  buildScoreBySubmissionId,
  buildUserScoreRow,
  buildAiScoreRows,
  buildMarksRows,
  hasAnyUserScore,
  hasExportableScores,
  omitEmptyUserScoreColumns,
} from '../tools/exportUserScores.js';
import {
  extractAiScoreFromAssessment as parseAiScore,
  summariseSubmissionAnswers as summariseAnswers,
} from '../tools/submissionProgress.js';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';

import Localization from "../Localization.jsx"

import RootPage from "../pages/RootPage.jsx"
import RetrieverBar from "../views/retriever/RetrieverBar.jsx"
import SubmissionDetail from "../views/retriever/SubmissionDetail.jsx"
import SubmissionDetailMapDialog from "../views/retriever/SubmissionDetailMapDialog.jsx"
import AIAssessmentPage from "../views/retriever/AIAssessmentPage.jsx"
import OverallAssessmentPage from "../views/retriever/OverallAssessmentPage.jsx"
import {  IconButton, Tooltip, Button } from '@mui/material';
import {
  grey,
} from '@mui/material/colors'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  Card,
  CardContent,
  Grid,
  Divider,
  Typography,
  ListItemSecondaryAction,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Chip,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
  ToggleButton,
} from '@mui/material';
import Paper from '@mui/material/Paper';
// Timeline components
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Config from '../Config';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { withTheme } from '@mui/styles';

const
    XLSX = require('xlsx');

const RET_VIEW_DATES = 0;
const RET_VIEW_SUBMISSION_GROUPS = 1;
const RET_VIEW_SUBMISSION_HISTORY = 2;

// Answered and all-questions scores share the toy icon, so they take two
// colours. AI Score (all) keeps the magenta used for AI output elsewhere.
// AI Score (answered) takes the blue.
const AI_ACCENT = '#3949ab';
const AI_ALL_ACCENT = '#ad1179';
// The full-paper total keeps the green the marks bar already used. The
// answered-only total sits above it, so it takes a lighter green.
const MARKS_ANSWERED_ACCENT = '#7cb342';

// One colour per metric on a submission card, so a bar is identifiable at a
// glance without reading its icon. Yellow is a deeper 700-weight rather than a
// pure yellow — a 6px bar of #ffeb3b on the light grey track is barely visible.
const QUESTION_ACCENT = '#4caf50';   // green
const HOTSPOT_ACCENT = '#fbc02d';    // yellow

// A tooltip nobody knows to hover is invisible, so text that carries one is
// marked as such rather than looking like plain text. Used for the standalone
// "not marked" line; the bar rows advertise themselves by hovering as a whole.
const HOVERABLE_COUNTER_STYLE = {
  whiteSpace: 'nowrap',
  cursor: 'help',
  textDecoration: 'underline dotted',
  textUnderlineOffset: '3px',
  textDecorationColor: grey[400],
};

// One width for every bar label so they right-align into a column instead of
// stepping in and out. Sized for the longest ("AI Score (answered): 100%").
const CARD_LABEL_WIDTH = '220px';

const formatMark = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  const rounded = Math.round(n * 100) / 100;
  return String(rounded);
};

class RetrieverPage extends React.Component {
  static RET_VIEW_DATES() {
    return RET_VIEW_DATES;
  }

  static RET_VIEW_SUBMISSION_GROUPS() {
    return RET_VIEW_SUBMISSION_GROUPS;
  }

  static RET_VIEW_SUBMISSION_HISTORY() {
    return RET_VIEW_SUBMISSION_HISTORY;
  }

  constructor(props) {
    super(props);
    this.submissionDetailRef = React.createRef();
    this.retrieverBarRef = React.createRef();
    this.timelineScrollRef = React.createRef();
    // Monotonically increasing token to ignore stale score-enrichment callbacks
    this.scoreEnrichmentRequestId = 0;
    // Same idea one level up: a date selection can be superseded before its
    // request(s) return (the multi-date load fans out one request per date), and
    // an older batch committing last would list the wrong date's submissions and
    // close whatever submission the user had opened.
    this.submissionLoadId = 0;
    // The "Question: x/y" and "Hotspot: a/b" counters are derived from the bulk
    // answer tree (no column backs either), so they get the same stale-response
    // token, plus a key of the id set they were fetched for: a re-sort must not
    // refire that heavy request.
    this.submissionProgressRequestId = 0;
    this.submissionProgressKey = '';

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      status: RET_VIEW_DATES,
      currentLocaleId: this.props.localeData.id,
      currentDate: "",
      selectedDates: [],        // Array of selected dates for multi-selection
      submissionGroupList: [],
      submissionList: [],
      selectedIndex: -1,
      isSharable: 0,
      shareToken: '',
      shareDialogOpen: false,
      sharingUrl: '',
      timelineScrollLeft: 0,
      showScrollButtons: false,
      shouldCenterTimeline: true,
      dateFilterStart: '',
      dateFilterEnd: '',
      showAllDates: true,
      tempDateFilterStart: '',
      tempDateFilterEnd: '',
      scrollInterval: null,     // For continuous scrolling
      scrollDirection: null,    // Track scroll direction
      isDragging: false,        // Track drag state
      dragStartX: 0,           // Initial mouse X position
      dragStartScrollLeft: 0,  // Initial scroll position
      actualFilterDate: null,   // Store actual date with submissions for API calls
      submissionSortOption: 'time_desc', // Default: 提交時間(晚至早)
      // Off until the teacher asks: the answered-only AI score and marks
      // rows are extra detail on top of the all-questions rows.
      showAnsweredQuestions: false,
      sortedSubmissionList: [],
      showCopyMessage: false,
      answeredCountBySubmissionId: {}, // submission id -> questions answered
      visitedHotspotCountBySubmissionId: {}, // submission id -> hotspots answered in
      hotspotBreakdownBySubmissionId: {},    // submission id -> [{name, answered, total}]
      aiPercentBySubmissionId: {},           // submission id -> mean AI percentage of answered questions
      aiPercentAllBySubmissionId: {},        // submission id -> mean AI percentage of every AI question
      submissionProgressById: {},            // submission id -> totals the class summary averages
      totalQuestionCount: null,        // questions in this locale (null = unknown yet)
      totalHotspotCount: null,         // hotspots in this locale (null = unknown yet)
    };
    autoBind(this);

    // Initialize temp date values
    this.state.tempDateFilterStart = this.state.dateFilterStart;
    this.state.tempDateFilterEnd = this.state.dateFilterEnd;

    this.refresh();
  }

  componentDidMount() {
    console.log('RetrieverPage rendered');
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    setTimeout(() => this.checkTimelineOverflow(), 100);
    
    // Add drag scrolling support for timeline
    setTimeout(() => {
      if (this.timelineScrollRef.current) {
        this.timelineScrollRef.current.addEventListener('mousedown', this.handleTimelineMouseDown);
        // Set initial cursor style
        this.timelineScrollRef.current.style.cursor = 'grab';
      }
    }, 200);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    // Clean up continuous scroll interval to prevent memory leaks
    this.stopContinuousScroll();
    
    // Clean up drag scrolling event listeners
    if (this.timelineScrollRef.current) {
      this.timelineScrollRef.current.removeEventListener('mousedown', this.handleTimelineMouseDown);
    }
    // Clean up global event listeners in case they're still attached
    document.removeEventListener('mousemove', this.handleTimelineMouseMove);
    document.removeEventListener('mouseup', this.handleTimelineMouseUp);
    // Drop any submission-progress response still in flight
    this.submissionProgressRequestId += 1;
  }

  initWindowDimensions() {

  }

  updateWindowDimensions() {
    // We no longer need to calculate a fixed height
    // The List components now use a more responsive approach
    // This method is kept for future use or in case we need window dimensions for other purposes
  }

  refresh() {
    console.log('school id:', this.props.root.getMySchoolId(), 'locale id:', this.state.currentLocaleId);
    switch(this.state.status) {
      case RET_VIEW_DATES:
        console.log("get_submission_groups_by_epack");
        this.props.root.refs.API.request("get_submission_groups_by_epack", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId }, this.getSubmissionGroupByLocaleOK, this.getSubmissionGroupByLocaleFailed);
        break;
      case RET_VIEW_SUBMISSION_GROUPS: {
        console.log("get_submission_list_by_epack_and_date");
        // console.log('send get_submission_list_by_epack_and_date req:', { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:this.state.currentDate });
        const loadId = ++this.submissionLoadId;
        this.props.root.refs.API.request(
          "get_submission_list_by_epack_and_date",
          { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:this.state.currentDate },
          (res) => { if (loadId === this.submissionLoadId) { this.getSubmissionGroupByDateOK(res); } },
          (err) => { if (loadId === this.submissionLoadId) { this.getSubmissionGroupByDateFailed(err); } }
        );
        break;
      }
      default:
        break;
    }
  }

  getSubmissionGroupByLocaleOK(res) {
    const groupList = res.body['result'] || [];
    this.setState({submissionGroupList: groupList}, () => {
      setTimeout(() => this.checkTimelineOverflow(), 100);
      
      // Also try to scroll to latest date after timeline is updated
      if (this.state.status === RET_VIEW_SUBMISSION_GROUPS && this.state.currentDate) {
        setTimeout(() => {
          console.log('Attempting scroll from setState callback');
          this.scrollToLatestDate(this.state.currentDate);
        }, 500);
      }
    });

    // Auto-select latest date and switch to date view
    if ((this.state.status === RET_VIEW_DATES) || (this.state.currentDate === "")) {
      if (groupList.length > 0) {
        let latest = groupList.reduce((acc, row) => {
          const t = new Date(row['submission_time']).getTime();
          return (acc.time < t) ? { time: t, value: row['submission_time'] } : acc;
        }, { time: -Infinity, value: groupList[0]['submission_time'] });

        console.log('Auto-selecting latest date:', latest.value);
        this.setState({
          status: RET_VIEW_SUBMISSION_GROUPS,
          currentDate: latest.value,
          selectedDates: [latest.value], // Ensure selectedDates includes the latest date
          selectedIndex: -1,
          // Clear any existing date filters to show the actual latest date
          dateFilterStart: '',
          dateFilterEnd: '',
          tempDateFilterStart: '',
          tempDateFilterEnd: '',
          showAllDates: true,
        });
        this.state.status = RET_VIEW_SUBMISSION_GROUPS;
        this.state.currentDate = latest.value;
        this.state.selectedDates = [latest.value];
        this.state.selectedIndex = -1;
        this.state.dateFilterStart = '';
        this.state.dateFilterEnd = '';
        this.state.tempDateFilterStart = '';
        this.state.tempDateFilterEnd = '';
        this.state.showAllDates = true;
        this.refresh();
        
        // Scroll to the latest date in the timeline after everything is loaded
        setTimeout(() => {
          console.log('Attempting to scroll to latest date after delay');
          this.scrollToLatestDate(latest.value);
        }, 1000); // Increased delay to ensure timeline is fully rendered
      }
    }
  }

  scrollToLatestDate(latestDate, retryCount = 0) {
    if (!latestDate) {
      console.log('No latest date provided');
      return;
    }

    if (!this.timelineScrollRef.current) {
      console.log('Timeline ref not available, retry count:', retryCount);
      if (retryCount < 5) {
        // Retry after a short delay
        setTimeout(() => {
          this.scrollToLatestDate(latestDate, retryCount + 1);
        }, 500);
      }
      return;
    }

    const container = this.timelineScrollRef.current;
    if (!container.scrollWidth || container.scrollWidth <= container.clientWidth) {
      console.log('Timeline not ready for scrolling, retry count:', retryCount);
      if (retryCount < 5) {
        setTimeout(() => {
          this.scrollToLatestDate(latestDate, retryCount + 1);
        }, 500);
      }
      return;
    }

    console.log('Scrolling to latest date:', latestDate, 'attempt:', retryCount + 1);
    
    // Get all dates sorted chronologically
    const allDates = [...this.state.submissionGroupList].sort((a, b) => 
      new Date(a.submission_time) - new Date(b.submission_time)
    );
    
    // Find the index of the latest date
    let targetIndex = allDates.findIndex(item => item.submission_time === latestDate);
    
    if (targetIndex < 0) {
      console.log('Latest date not found in timeline');
      return;
    }
    
    console.log('Latest date index:', targetIndex, 'of', allDates.length, 'dates');
    
    // Group dates by year for accurate positioning
    const groups = {};
    allDates.forEach((row) => {
      const d = new Date(row.submission_time);
      const y = d.getFullYear();
      if (!groups[y]) groups[y] = [];
      groups[y].push(row);
    });
    
    const years = Object.keys(groups).sort((a, b) => Number(a) - Number(b));
    
    // Find which year and position within year our target is
    let cumulativeIndex = 0;
    let targetYearIndex = 0;
    let positionInYear = 0;
    
    for (let yearIdx = 0; yearIdx < years.length; yearIdx++) {
      const year = years[yearIdx];
      const yearDates = groups[year];
      
      if (cumulativeIndex + yearDates.length > targetIndex) {
        targetYearIndex = yearIdx;
        positionInYear = targetIndex - cumulativeIndex;
        break;
      }
      cumulativeIndex += yearDates.length;
    }
    
    console.log('Latest date is in year', years[targetYearIndex], 'at position', positionInYear);
    
    // For latest date, scroll to the end of the timeline to show the most recent dates
    const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
    const finalScroll = maxScroll; // Scroll to the very end
    
    console.log('Scrolling to end position:', finalScroll, 'Container width:', container.clientWidth, 'Scroll width:', container.scrollWidth);
    
    // Scroll to the position immediately since we already have retries
    try {
      container.scrollTo({
        left: finalScroll,
        behavior: 'smooth'
      });
      console.log('Smooth scroll initiated to position:', finalScroll);
    } catch (e) {
      console.log('Smooth scroll failed, using direct scroll');
      container.scrollLeft = finalScroll;
    }
    
    // Verify scroll happened
    setTimeout(() => {
      const currentScroll = container.scrollLeft;
      console.log('Current scroll position after scroll:', currentScroll, 'Target was:', finalScroll);
      
      if (Math.abs(currentScroll - finalScroll) > 10) {
        console.log('Scroll verification failed, forcing direct scroll');
        container.scrollLeft = finalScroll;
      } else {
        console.log('✅ Successfully scrolled to latest date position');
      }
    }, 1000);
  }

  getSubmissionGroupByLocaleFailed(err) {
    console.log("get submission group by locale failed");
  }

  getSubmissionGroupByDateOK(res) {
    const list = res.body['result'] || [];
    this.commitSubmissionList(list);
  }

  getSubmissionGroupByDateFailed(err) {
    console.log("get submission group by date failed");
  }

  handleDateClicked(date, changeHistory=true, isCtrlClick=false) {
    let shouldPushHistory = changeHistory;

    if (isCtrlClick) {
      // Multi-select with Cmd/Ctrl now toggles the clicked date itself (no range auto-selection)
      let newSelectedDates = [...this.state.selectedDates];
      if (newSelectedDates.includes(date)) {
        newSelectedDates = newSelectedDates.filter(d => d !== date);
      } else {
        newSelectedDates.push(date);
      }

      // Ensure uniqueness and keep chronological order
      newSelectedDates = [...new Set(newSelectedDates)].sort((a, b) => new Date(a) - new Date(b));

      // Keep the last selected date (if any) as current for styling; clear if none remain
      const nextCurrentDate = newSelectedDates.length > 0 ? newSelectedDates[newSelectedDates.length - 1] : "";
      shouldPushHistory = changeHistory && newSelectedDates.length > 0;

      // If nothing remains selected, just clear data but stay on the same page
      if (newSelectedDates.length === 0) {
        this.setState({
          status: RET_VIEW_SUBMISSION_GROUPS,
          selectedDates: [],
          currentDate: "",
          selectedIndex: -1,
          submissionList: [],
          sortedSubmissionList: [],
          dateFilterStart: '',
          dateFilterEnd: '',
          tempDateFilterStart: '',
          tempDateFilterEnd: '',
          actualFilterDate: null,
          showAllDates: true,
        });
        this.state.status = RET_VIEW_SUBMISSION_GROUPS;
        this.state.selectedDates = [];
        this.state.currentDate = "";
        this.state.selectedIndex = -1;
        this.state.submissionList = [];
        this.state.sortedSubmissionList = [];
      } else {
        this.setState({
          status: RET_VIEW_SUBMISSION_GROUPS, // Set status to show submission data
          selectedDates: newSelectedDates,
          currentDate: nextCurrentDate,
          selectedIndex: -1,
          // Clear single-date mode filters when using multi-select
          dateFilterStart: '',
          dateFilterEnd: '',
          tempDateFilterStart: '',
          tempDateFilterEnd: '',
          showAllDates: true,
        });
        this.state.status = RET_VIEW_SUBMISSION_GROUPS; // Also set state directly
        this.state.selectedDates = newSelectedDates;
        this.state.currentDate = nextCurrentDate;
        this.state.selectedIndex = -1;
        
        // Load submissions for all selected dates
        this.loadSubmissionsForMultipleDates(newSelectedDates);
      }
      
    } else {
      // Single selection mode (normal click)
      const isTogglingOff = this.state.currentDate === date && this.state.selectedDates.includes(date);

      if (isTogglingOff) {
        // Clicking the same date again clears the selection
        this.setState({
          status: RET_VIEW_SUBMISSION_GROUPS,
          currentDate: "",
          selectedDates: [],
          submissionList: [],
          sortedSubmissionList: [],
          selectedIndex: -1,
          showAllDates: true,
          actualFilterDate: null,
        });
        this.state.status = RET_VIEW_SUBMISSION_GROUPS;
        this.state.currentDate = "";
        this.state.selectedDates = [];
        this.state.submissionList = [];
        this.state.sortedSubmissionList = [];
        this.state.selectedIndex = -1;
        shouldPushHistory = false;
        return;
      }

      this.setState({
        status: RET_VIEW_SUBMISSION_GROUPS,
        currentDate: date,
        selectedDates: [date], // Single date in array
        selectedIndex: -1,
        // Clear filter when selecting single date
        dateFilterStart: '',
        dateFilterEnd: '',
        tempDateFilterStart: '',
        tempDateFilterEnd: '',
        showAllDates: true,
      });
      this.state.status = RET_VIEW_SUBMISSION_GROUPS;
      this.state.currentDate = date;
      this.state.selectedDates = [date];
      this.state.selectedIndex = -1;
      this.refresh();
    }

    if (shouldPushHistory) {
      this.props.root.pushHistory("retriever/date");
    }
  }

  getAllAvailableDates() {
    // Get all available dates from submissionGroupList, sorted chronologically
    return this.state.submissionGroupList
      .map(item => item.submission_time)
      .sort((a, b) => new Date(a) - new Date(b));
  }

  /**
   * The calendar day of a value, as 'YYYY-MM-DD'.
   *
   * The date-range filter compares two things that `new Date()` parses in
   * DIFFERENT time zones: the <input type="date"> bounds are bare 'YYYY-MM-DD',
   * which the spec parses as UTC midnight, while `submission_time` is a
   * timestamp, which V8 parses as LOCAL time. In UTC+8 that put the end
   * boundary at 08:00 local, so every field trip after 8am on the end date was
   * silently dropped from the range. Comparing calendar days as strings removes
   * the time zone from the comparison entirely.
   */
  dayOf(value) {
    if (!value) {
      return "";
    }
    return String(value).trim().split(/[ T]/)[0];
  }

  getDateRange(startDate, endDate, allAvailableDates) {
    let start = this.dayOf(startDate);
    let end = this.dayOf(endDate);

    if (start && end && start > end) {
      // Swap if end date is before start date
      const swap = start; start = end; end = swap;
    }

    // Filter dates that fall within the range
    return allAvailableDates.filter(dateStr => {
      const day = this.dayOf(dateStr);
      return day >= start && day <= end;
    });
  }

  /**
   * May this user administer the locale being retrieved?
   *
   * A locale another school authored can still be RETRIEVED here (our students
   * submitted to it), but every manual-AI-assessment route is gated
   * `assert_epack_writable` server-side, so offering those actions on a locale
   * we do not own only produces 403s. Same rule as the locale card's edit
   * icons (LocaleListView).
   */
  canManageLocale() {
    const locale = this.props.localeData || {};
    const root = this.props.root;
    return !!(
      root.isAdminUser() ||
      (root.getSameSchoolEdit() && locale['school_id'] == root.getMySchoolId()) ||
      root.getMyUserId() == locale['user_id']
    );
  }

  loadSubmissionsForMultipleDates(selectedDates) {
    if (selectedDates.length === 0) {
      this.clearSubmissionListState();
      return;
    }

    // Set loading state
    this.setState({ status: RET_VIEW_SUBMISSION_GROUPS });
    this.state.status = RET_VIEW_SUBMISSION_GROUPS;

    // Any selection made while this batch is in flight supersedes it.
    const loadId = ++this.submissionLoadId;

    // Use a closure to maintain the submissions array
    const loadMultipleSubmissions = () => {
      const allSubmissions = [];
      let completedRequests = 0;
      const totalRequests = selectedDates.length;

      selectedDates.forEach(dateItem => {
        // Handle both date strings and date group objects
        const dateStr = (typeof dateItem === 'string') ? dateItem : dateItem.submission_time;

        this.props.root.refs.API.request("get_submission_list_by_epack_and_date",
          { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date: dateStr },
          (res) => {
            // Success callback. On the OK path result may be null or a non-array
            // (see tools/API.jsx), and spreading that would throw here.
            const submissions = (res && res.body && Array.isArray(res.body['result'])) ? res.body['result'] : [];
            allSubmissions.push(...submissions);
            completedRequests++;

            if (completedRequests === totalRequests) {
              if (loadId !== this.submissionLoadId) {
                return; // a newer date selection already owns the list
              }
              const updated = allSubmissions;
              const actualFilterDate = allSubmissions.length > 0
                ? this.dayOf(allSubmissions[0].submission_time)
                : null;
              this.commitSubmissionList(updated, { resetSelection: true, actualFilterDate });
              console.log(`Multi-date selection loaded ${updated.length} submissions from ${totalRequests} dates`);
            }
          },
          (err) => {
            // Error callback
            console.error("Failed to get submissions for date:", dateStr, err);
            completedRequests++;

            if (completedRequests === totalRequests) {
              if (loadId !== this.submissionLoadId) {
                return;
              }
              this.commitSubmissionList(allSubmissions, { resetSelection: true });
            }
          }
        );
      });
    };

    // Execute the loading function
    loadMultipleSubmissions();
  }

  clearSubmissionListState() {
    this.setState({
      submissionList: [],
      sortedSubmissionList: [],
      selectedIndex: -1,
    });
    this.state.submissionList = [];
    this.state.sortedSubmissionList = [];
    this.state.selectedIndex = -1;
    this.loadSubmissionProgress([]);
  }

  extractAiScoreFromAssessment(assessmentText) {
    return parseAiScore(assessmentText);
  }

  hasTraditionalSubmissionScore(item) {
    if (!item) return false;
    const rawScore = item.score !== undefined && item.score !== null
      ? item.score
      : item.score_value;
    const rawMax = item.score_max !== undefined && item.score_max !== null
      ? item.score_max
      : item.max_score;
    if (rawScore === undefined || rawScore === null || rawScore === '') return false;
    const scoreNum = parseFloat(rawScore);
    if (isNaN(scoreNum) || scoreNum < 0) return false;
    if (rawMax === undefined || rawMax === null || rawMax === '') return scoreNum > 0;
    const maxNum = parseFloat(rawMax);
    return !isNaN(maxNum) && maxNum > 0;
  }

  getSubmissionSortMetric(item) {
    if (!item) return null;

    if (item.ai_average_score !== undefined && item.ai_average_score !== null && item.ai_average_score !== '') {
      const aiAvg = parseFloat(item.ai_average_score);
      if (!isNaN(aiAvg) && aiAvg >= 0) {
        return aiAvg;
      }
    }

    const rawScore = item.score !== undefined && item.score !== null
      ? item.score
      : item.score_value;
    const rawMax = item.score_max !== undefined && item.score_max !== null
      ? item.score_max
      : item.max_score;

    if (rawScore !== undefined && rawScore !== null && rawScore !== '') {
      const parsedScore = parseFloat(rawScore);
      if (!isNaN(parsedScore) && parsedScore < 0) {
        return null;
      }
    }

    let scoreNum = null;
    if (rawScore !== undefined && rawScore !== null && rawScore !== '') {
      const parsed = parseFloat(rawScore);
      if (!isNaN(parsed) && parsed >= 0) {
        scoreNum = parsed;
      }
    }

    let maxNum = null;
    if (rawMax !== undefined && rawMax !== null && rawMax !== '') {
      const parsed = parseFloat(rawMax);
      if (!isNaN(parsed) && parsed > 0) {
        maxNum = parsed;
      }
    }

    if (scoreNum !== null && maxNum !== null) {
      return (scoreNum / maxNum) * 100;
    }

    if (item.percent !== undefined && item.percent !== null && item.percent !== '') {
      const percent = parseFloat(item.percent);
      if (!isNaN(percent) && percent >= 0) {
        return percent;
      }
    }

    if (scoreNum !== null) {
      return scoreNum;
    }

    return null;
  }

  applySubmissionSort(list, optionOverride) {
    const option = optionOverride || this.state.submissionSortOption;
    const clone = Array.isArray(list) ? [...list] : [];
    const getTime = (item) => new Date(item.submission_time).getTime();

    clone.sort((a, b) => {
      switch (option) {
        case 'time_asc':
          return getTime(a) - getTime(b);
        case 'score_desc': {
          const sa = this.getSubmissionSortMetric(a);
          const sb = this.getSubmissionSortMetric(b);
          if (sa === null && sb === null) return getTime(b) - getTime(a);
          if (sa === null) return 1;
          if (sb === null) return -1;
          if (sb !== sa) return sb - sa;
          return getTime(b) - getTime(a);
        }
        case 'score_asc': {
          const sa = this.getSubmissionSortMetric(a);
          const sb = this.getSubmissionSortMetric(b);
          if (sa === null && sb === null) return getTime(b) - getTime(a);
          if (sa === null) return 1;
          if (sb === null) return -1;
          if (sa !== sb) return sa - sb;
          return getTime(b) - getTime(a);
        }
        case 'time_desc':
        default:
          return getTime(b) - getTime(a);
      }
    });

    return clone;
  }

  getSubmissionDatesFromList(list) {
    if (!Array.isArray(list)) return [];
    return [...new Set(
      list
        .map((item) => (item && item.submission_time ? item.submission_time.split(' ')[0] : null))
        .filter(Boolean)
    )];
  }

  applyAiScoresToSubmissionList(list, aiScoresByUserDate) {
    return list.map((item) => {
      if (!item || this.hasTraditionalSubmissionScore(item)) {
        return item;
      }

      const dateStr = (item.submission_time || '').split(' ')[0];
      const aiAvg = aiScoresByUserDate[`${dateStr}|${item.user_name}`];
      if (aiAvg === undefined || aiAvg === null) {
        return item;
      }

      const rounded = Math.round(aiAvg * 100) / 100;
      // ANNOTATE ONLY. This used to also write score: rounded, score_max: 100,
      // percent: rounded — which destroyed the row's real marks, so a card could
      // never show the AI percentage and the marks side by side, switching back
      // to a time sort never restored the DB values, and the fake score_max of
      // 100 made a percentage look like a mark out of 100.
      // getSubmissionSortMetric already prefers ai_average_score, so score
      // sorting is unaffected.
      return { ...item, ai_average_score: rounded };
    });
  }

  enrichSubmissionListWithScores(list, callback) {
    if (!Array.isArray(list) || list.length === 0) {
      if (callback) callback([]);
      return;
    }

    const dates = this.getSubmissionDatesFromList(list);
    if (dates.length === 0) {
      if (callback) callback(list);
      return;
    }

    const aiScoresByUserDate = {};
    let completed = 0;

    const finishDate = () => {
      completed += 1;
      if (completed >= dates.length && callback) {
        callback(this.applyAiScoresToSubmissionList(list, aiScoresByUserDate));
      }
    };

    dates.forEach((date) => {
      this.props.root.refs.API.request(
        'get_all_ai_assessment_response',
        {
          locale_id: this.state.currentLocaleId,
          date: `${date} 00:00:00`,
          school_id: this.props.root.getMySchoolId(),
        },
        (res) => {
          const students = (res && res.body && Array.isArray(res.body.result)) ? res.body.result : [];
          students.forEach((student) => {
            const assessments = student.assessments || [];
            const scores = assessments
              .map((assessment) => this.extractAiScoreFromAssessment(assessment.ai_assessment))
              .filter((score) => score !== null && !isNaN(score));
            if (scores.length > 0) {
              const avg = scores.reduce((sum, score) => sum + score, 0) / scores.length;
              aiScoresByUserDate[`${date}|${student.user_name}`] = avg;
            }
          });
          finishDate();
        },
        () => finishDate()
      );
    });
  }

  /**
   * Totals, answered counts, and the per-hotspot breakdown for one submission.
   * The walk lives in submissionProgress.js so the card and the Excel export
   * share one definition of both AI percentages.
   */
  summariseSubmissionAnswers(hotspotList) {
    return summariseAnswers(hotspotList);
  }

  /**
   * Per-user totals for Excel. AI Score matches the answered-only card
   * average. AI Score (all) matches the card average taken over every
   * AI-assessable question, unanswered ones counting as 0%. Paper Score
   * prefers the submission-list marks, then the tree fallback.
   */
  getExportUserScores(hotspotList, submissionScoreRow, precomputedSummary) {
    const summary = precomputedSummary
      || this.summariseSubmissionAnswers(Array.isArray(hotspotList) ? hotspotList : []);
    const aiScore = (summary.aiPercent !== null && summary.aiPercent !== undefined)
      ? `${summary.aiPercent}%`
      : '';
    const aiScoreAll = (summary.aiPercentAll !== null && summary.aiPercentAll !== undefined)
      ? `${summary.aiPercentAll}%`
      : '';
    // Kept as {earned, max} as well as the "12/20" string: the Marks sheet
    // lifts the max into its column header and writes the earned marks alone.
    const paperParts = readPaperScorePartsFromSubmissionRow(submissionScoreRow)
      || computePaperScorePartsFromHotspotList(hotspotList);
    // The list row is the whole paper. The tree total is the same figure,
    // kept beside it so a download names the all-questions score explicitly.
    const paperAllParts = (summary && summary.maxMarks > 0)
      ? { earned: summary.earnedMarks, max: summary.maxMarks }
      : paperParts;
    return {
      aiScore,
      aiScoreAll,
      paperScore: formatPaperScore(paperParts),
      paperScoreAll: formatPaperScore(paperAllParts),
      paperParts,
      paperAllParts,
    };
  }

  /**
   * Everything the three score exports need out of one submission: the two
   * totals AND the per-hotspot breakdown behind them. summariseSubmissionAnswers
   * walks the whole answer tree, so it is run once here and shared.
   */
  buildExportScoreEntry(submissionData, hotspotList, submissionScoreRow) {
    const list = Array.isArray(hotspotList) ? hotspotList : [];
    const summary = this.summariseSubmissionAnswers(list);
    const totals = this.getExportUserScores(list, submissionScoreRow, summary);
    return {
      udid: submissionData.udid,
      username: submissionData.user_name,
      submissionId: submissionData.id,
      submissionTime: submissionData.submission_time,
      aiScore: totals.aiScore,
      aiScoreAll: totals.aiScoreAll,
      paperScore: totals.paperScore,
      paperScoreAll: totals.paperScoreAll,
      paperParts: totals.paperParts,
      paperAllParts: totals.paperAllParts,
      breakdown: summary.breakdown,
    };
  }

  /**
   * The score-only path through a download_ans_batch response. It skips the
   * answer rows entirely -- those are thousands of objects the score sheets
   * never look at.
   */
  extractExportScoreEntries(answers, scoreBySubmissionId) {
    const scoreLookup = scoreBySubmissionId || {};
    let parsed;
    try {
      parsed = JSON.parse(answers).result;
    } catch (e) {
      console.error('Failed to parse answers for score export:', e);
      return [];
    }
    if (!parsed || !Array.isArray(parsed.submission_list)) {
      console.error('No result in answers for score export');
      return [];
    }
    const entries = [];
    parsed.submission_list.forEach((item) => {
      // Same empty shell as tidy_ans_batch guards against.
      const submissionData = item && item.submission_data;
      if (!submissionData) return;
      entries.push(this.buildExportScoreEntry(
        submissionData,
        item.hotspot_list,
        scoreLookup[String(submissionData.id)]
      ));
    });
    return entries;
  }

  /**
   * Compact bar + label for the right-hand end of the name / time rows. The two
   * counters keep the position they had as plain text, but read as progress.
   */
  renderCardInlineProgress({ blockKey, icon, color, percent, tooltip }) {
    const value = isNaN(percent) ? 0 : Math.max(0, Math.min(100, percent));
    const block = (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flex: 'none',
          borderRadius: '4px',
          px: 0.75,
          // A 6px bar is a small hover target, so the block is padded out
          // vertically — the count now lives ONLY in the tooltip, which makes
          // hovering the difference between seeing it and not.
          py: 0.75,
          ...(tooltip ? { cursor: 'help', '&:hover': { backgroundColor: grey[100] } } : null),
        }}
      >
        {/* The icon says which metric this is, so the bar itself can be short
            and give the width back to the student name beside it. */}
        <Icon style={{ color: color, fontSize: '18px' }}>{icon}</Icon>
        <Box style={{ width: '60px' }}>
          <LinearProgress
            variant="determinate"
            value={value}
            sx={{
              height: 6,
              borderRadius: '9999px',
              backgroundColor: grey[300],
              '& .MuiLinearProgress-bar': {
                backgroundColor: color,
                borderRadius: '9999px',
              },
            }}
          />
        </Box>
      </Box>
    );

    if (!tooltip) {
      return <React.Fragment key={blockKey}>{block}</React.Fragment>;
    }
    return (
      <Tooltip key={blockKey} arrow placement="left" title={tooltip}>
        {block}
      </Tooltip>
    );
  }

  /**
   * One metric row on a submission card: icon, bar, right-aligned label. Every
   * row shares this shape so the card reads as one stack of progress bars.
   * `tooltip` also drives the hover affordance — no tip, no dotted underline.
   */
  renderCardProgressRow({ rowKey, icon, iconNode, color, labelColor, percent, label, tooltip }) {
    const value = isNaN(percent) ? 0 : Math.max(0, Math.min(100, percent));
    const row = (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          mt: 1,
          mx: -0.5,
          px: 0.5,
          borderRadius: '4px',
          // The tooltip covers the whole row, so the whole row is what lights
          // up — a dotted underline on the label alone pointed at the wrong
          // target, and four of them stacked was just noise.
          ...(tooltip ? { cursor: 'help', '&:hover': { backgroundColor: grey[100] } } : null),
        }}
      >
        {iconNode || <Icon style={{ color: color, fontSize: '20px' }}>{icon}</Icon>}
        <Box style={{ flex: 1, minWidth: 0 }}>
          <LinearProgress
            variant="determinate"
            value={value}
            sx={{
              height: 6,
              borderRadius: '9999px',
              // A dark track made an empty bar read as a full one; the fill is
              // the signal, so the track recedes.
              backgroundColor: grey[300],
              '& .MuiLinearProgress-bar': {
                backgroundColor: color,
                borderRadius: '9999px',
              },
            }}
          />
        </Box>
        <Typography
          variant="body2"
          style={{
            minWidth: CARD_LABEL_WIDTH,
            textAlign: 'right',
            whiteSpace: 'nowrap',
            color: labelColor || grey[800],
          }}
        >
          {label}
        </Typography>
      </Box>
    );

    if (!tooltip) {
      return <React.Fragment key={rowKey}>{row}</React.Fragment>;
    }
    return (
      <Tooltip key={rowKey} arrow placement="left" title={tooltip}>
        {row}
      </Tooltip>
    );
  }

  /**
   * Tooltip body for a counter: what it means, then the per-hotspot detail.
   * `mode` picks the right-hand column — answered questions, a visited mark, or
   * how many of the hotspot's questions carry marks at all.
   */
  renderProgressTooltip(heading, breakdown, mode, countLabel) {
    const MAX_TIP_ROWS = 12;
    // A content-only hotspot has nothing to answer or to mark, so it is noise in
    // those breakdowns, but it still counts towards the hotspot total.
    let rows = breakdown || [];
    if (mode === 'question' || mode === 'marks') {
      rows = rows.filter((hotspot) => hotspot.total > 0);
    } else if (mode === 'earned') {
      // Only hotspots that carry marks contribute to the (x/y) being explained.
      rows = rows.filter((hotspot) => hotspot.max > 0);
    } else if (mode === 'earnedAnswered') {
      rows = rows.filter((hotspot) => hotspot.maxAnswered > 0);
    } else if (mode === 'ai') {
      rows = rows.filter((hotspot) => hotspot.aiPercent !== null && hotspot.aiPercent !== undefined);
    } else if (mode === 'aiAll') {
      rows = rows.filter((hotspot) => hotspot.aiPercentAll !== null && hotspot.aiPercentAll !== undefined);
    }
    const shown = rows.slice(0, MAX_TIP_ROWS);
    const hidden = rows.length - shown.length;

    const columnFor = (hotspot) => {
      if (mode === 'hotspot') {
        return hotspot.answered > 0 ? '✓' : '—';
      }
      if (mode === 'marks') {
        return `${hotspot.marked}/${hotspot.total}`;
      }
      if (mode === 'earned') {
        return `${formatMark(hotspot.earned)}/${formatMark(hotspot.max)}`;
      }
      if (mode === 'earnedAnswered') {
        return `${formatMark(hotspot.earnedAnswered)}/${formatMark(hotspot.maxAnswered)}`;
      }
      if (mode === 'ai') {
        return `${hotspot.aiPercent}%`;
      }
      if (mode === 'aiAll') {
        return `${hotspot.aiPercentAll}%`;
      }
      return `${hotspot.answered}/${hotspot.total}`;
    };

    return (
      <Box>
        {/* For a bar with no visible label, this line IS the count — it is the
            only place "問題: 1/20" appears, so it leads and the explanation
            drops to secondary weight underneath it. */}
        {countLabel && (
          <Typography
            variant="body2"
            // Explicit white rather than inheriting the popper's colour: this is
            // the headline number of the tip and should not dim with the
            // explanation beneath it. Covers 問題 and 熱點 alike.
            style={{ display: 'block', fontWeight: 700, marginBottom: '2px', color: '#fff' }}
          >
            {countLabel}
          </Typography>
        )}
        <Typography
          variant="caption"
          style={{ display: 'block', fontWeight: countLabel ? 400 : 600, opacity: countLabel ? 0.85 : 1 }}
        >
          {heading}
        </Typography>
        {shown.map((hotspot, index) => (
          <Box
            key={index}
            style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '2px' }}
          >
            <Typography
              variant="caption"
              style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {hotspot.name || '—'}
            </Typography>
            <Typography variant="caption" style={{ whiteSpace: 'nowrap' }}>
              {columnFor(hotspot)}
            </Typography>
          </Box>
        ))}
        {hidden > 0 && (
          <Typography variant="caption" style={{ display: 'block', marginTop: '2px' }}>
            {`+${hidden} ${Localization.strings.MORE || 'more'}`}
          </Typography>
        )}
      </Box>
    );
  }

  /**
   * Fill in "Question: x/y" and "Hotspot: a/b" for the cards on screen.
   *
   * Neither counter has a column behind it, so both come from the full answer
   * tree — the same cmd Compare Answers and the batch export use, and just as
   * expensive (one nested read per submission). It therefore runs AFTER the list
   * is painted, once per distinct submission-id set, and the cards show "–/N"
   * until it lands rather than blocking on it.
   */
  loadSubmissionProgress(list) {
    const ids = [...new Set(
      (Array.isArray(list) ? list : []).map((item) => (item ? item.id : null)).filter(Boolean)
    )];

    const clearCounts = {
      answeredCountBySubmissionId: {},
      visitedHotspotCountBySubmissionId: {},
      hotspotBreakdownBySubmissionId: {},
      aiPercentBySubmissionId: {},
      aiPercentAllBySubmissionId: {},
      submissionProgressById: {},
      totalQuestionCount: null,
      totalHotspotCount: null,
    };

    if (ids.length === 0) {
      this.submissionProgressRequestId += 1;
      this.submissionProgressKey = '';
      this.setState(clearCounts);
      return;
    }

    // A re-sort commits the same submissions in a different order; nothing to
    // re-fetch, and re-fetching would cost another full answer-tree read.
    const key = [...ids].sort().join(',');
    if (key === this.submissionProgressKey) {
      return;
    }
    this.submissionProgressKey = key;

    const requestId = ++this.submissionProgressRequestId;
    this.props.root.refs.API.request(
      'get_all_answers_in_submission_list',
      { submission_id_list: ids },
      (res) => {
        if (requestId !== this.submissionProgressRequestId) {
          return;
        }
        // res.body.result can be null/non-object on the OK path (see API.jsx).
        const result = res && res.body && res.body.result;
        const submissions = (result && Array.isArray(result.submission_list)) ? result.submission_list : [];

        const answeredCounts = {};
        const visitedCounts = {};
        const breakdowns = {};
        const aiPercents = {};
        const aiPercentsAll = {};
        const progressById = {};
        let totalQuestions = null;
        let totalHotspots = null;
        submissions.forEach((entry) => {
          if (!entry || !entry.submission_data) return;
          const hotspots = Array.isArray(entry.hotspot_list) ? entry.hotspot_list : [];
          const summary = this.summariseSubmissionAnswers(hotspots);
          // Every submission carries the whole epack's hotspots, but a deleted
          // submission comes back as an empty shell — take the largest.
          if (totalQuestions === null || summary.totalQuestions > totalQuestions) {
            totalQuestions = summary.totalQuestions;
          }
          if (totalHotspots === null || hotspots.length > totalHotspots) {
            totalHotspots = hotspots.length;
          }
          answeredCounts[entry.submission_data.id] = summary.answeredQuestions;
          visitedCounts[entry.submission_data.id] = summary.visitedHotspots;
          breakdowns[entry.submission_data.id] = summary.breakdown;
          aiPercents[entry.submission_data.id] = summary.aiPercent;
          aiPercentsAll[entry.submission_data.id] = summary.aiPercentAll;
          progressById[entry.submission_data.id] = {
            userName: entry.submission_data.user_name,
            aiPercentAll: summary.aiPercentAll,
            aiAllQuestionCount: summary.aiAllQuestionCount,
            earnedMarksAnswered: summary.earnedMarksAnswered,
            maxMarksAnswered: summary.maxMarksAnswered,
            questions: summary.questions,
          };
        });

        this.setState({
          answeredCountBySubmissionId: answeredCounts,
          visitedHotspotCountBySubmissionId: visitedCounts,
          hotspotBreakdownBySubmissionId: breakdowns,
          aiPercentBySubmissionId: aiPercents,
          aiPercentAllBySubmissionId: aiPercentsAll,
          submissionProgressById: progressById,
          totalQuestionCount: totalQuestions,
          totalHotspotCount: totalHotspots,
        });
      },
      () => {
        if (requestId !== this.submissionProgressRequestId) {
          return;
        }
        // Show no counters at all rather than a wrong 0/0, and let the next
        // commit of this same set try again.
        this.submissionProgressKey = '';
        this.setState(clearCounts);
      }
    );
  }

  commitSubmissionList(list, options = {}) {
    const safeList = Array.isArray(list) ? list : [];
    const sortOption = options.sortOption || this.state.submissionSortOption;
    const isScoreSort = sortOption === 'score_desc' || sortOption === 'score_asc';

    const applyCommit = (finalList) => {
      const sorted = this.applySubmissionSort(finalList, sortOption);
      const stateUpdate = {
        submissionList: finalList,
        sortedSubmissionList: sorted,
      };

      if (options.resetSelection) {
        stateUpdate.selectedIndex = -1;
      }
      if (options.actualFilterDate !== undefined) {
        stateUpdate.actualFilterDate = options.actualFilterDate;
      }

      this.setState(stateUpdate, () => {
        if (options.updateWindow !== false) {
          this.updateWindowDimensions();
        }
      });
      this.state.submissionList = finalList;
      this.state.sortedSubmissionList = sorted;
      if (options.resetSelection) {
        this.state.selectedIndex = -1;
      }
      this.loadSubmissionProgress(finalList);
    };

    if (isScoreSort && safeList.length > 0) {
      const requestId = ++this.scoreEnrichmentRequestId;
      this.enrichSubmissionListWithScores(safeList, (finalList) => {
        // Ignore stale enrichment callbacks if a newer request has been issued
        if (requestId !== this.scoreEnrichmentRequestId) {
          return;
        }
        applyCommit(finalList);
      });
    } else {
      // Bump the token so any in-flight score enrichment is ignored
      this.scoreEnrichmentRequestId += 1;
      applyCommit(safeList);
    }
  }

  handleSubmissionSortChange(e) {
    const newOption = e.target.value;
    const isScoreSort = newOption === 'score_desc' || newOption === 'score_asc';

    if (isScoreSort) {
      const interimSorted = this.applySubmissionSort(this.state.submissionList, newOption);
      this.setState({
        submissionSortOption: newOption,
        selectedIndex: -1,
        sortedSubmissionList: interimSorted,
      });
      const requestId = ++this.scoreEnrichmentRequestId;
      this.enrichSubmissionListWithScores(this.state.submissionList, (enriched) => {
        // Ignore stale enrichment callbacks if a newer request has been issued
        if (requestId !== this.scoreEnrichmentRequestId) {
          return;
        }
        const sorted = this.applySubmissionSort(enriched, newOption);
        this.setState({
          submissionList: enriched,
          sortedSubmissionList: sorted,
        });
        this.state.submissionList = enriched;
        this.state.sortedSubmissionList = sorted;
      });
      return;
    }

    // Bump the token so any in-flight score enrichment is ignored
    this.scoreEnrichmentRequestId += 1;
    const sorted = this.applySubmissionSort(this.state.submissionList, newOption);
    this.setState({
      submissionSortOption: newOption,
      selectedIndex: -1,
      sortedSubmissionList: sorted,
    });
    this.state.sortedSubmissionList = sorted;
    this.state.selectedIndex = -1;
  }

  /**
   * Jump from an aggregate chart straight to one student's answers.
   *
   * The distribution buckets only carry a user_name, so the submission is looked
   * up in the SAME sorted array the cards render from — selectedIndex is an
   * index into that array, and resolving against the unsorted list would select
   * the wrong card. A student with submissions on several dates resolves to the
   * first in the current sort order (the latest, by default).
   */
  handleStudentNameClicked(userName) {
    if (!userName) {
      return;
    }
    const list = (this.state.sortedSubmissionList.length === this.state.submissionList.length)
      ? this.state.sortedSubmissionList
      : this.applySubmissionSort(this.state.submissionList);
    const index = list.findIndex((item) => item && item.user_name === userName);
    if (index < 0) {
      console.log('No submission on screen for student', userName);
      return;
    }
    this.handleSubmissionClicked(index, list[index].id, list[index].user_name);
  }

  handleSubmissionClicked(index, submission_id, user_name) {
    this.setState({
      currentSubmissionId: submission_id,
      currentUsername: user_name,
      selectedIndex: index,
      isSharable: 0,
      shareToken: '',
    }, () => {
      this.refreshSubmissionDetail(submission_id);
      this.checkSharable(submission_id);
      
      if (this.retrieverBarRef.current) {
        this.retrieverBarRef.current.setState({ userOption: submission_id, showShareButton: false });
      }
    });
  }

  refreshSubmissionDetail(id) {
    if (this.submissionDetailRef.current) {
      this.submissionDetailRef.current.setState({ submissionId: id }, () => {
        this.submissionDetailRef.current.refresh();
      });
    }
  }

  /**
   * A browser BACK (or the bar's own back button) landed on us — LEAVE the
   * retriever.
   *
   * Opening the retriever pushes exactly ONE history entry
   * ("locale/retriever/date"), and nothing inside it pushes another: the date
   * strip and the student list only move local state, and handleDateClicked's
   * pushHistory("retriever/date") is always swallowed by pushHistory's
   * duplicate-path guard because the URL already ends in "retriever/date". So
   * one pop has to give that one entry back.
   *
   * This used to step DOWN a view instead (submission groups -> dates), which
   * spent the pop without releasing the entry: the address bar was already on
   * the locale list while the retriever stayed mounted, and every later back
   * press stayed one entry out of step. Worse, the dates view is one the user
   * has never seen — getSubmissionGroupByLocaleOK auto-selects the latest date
   * on entry — and its right-hand pane renders nothing (the xs=9 grid item is
   * gated on RET_VIEW_SUBMISSION_GROUPS), so a back press read as "everything
   * disappeared except the left menu".
   *
   * Nothing is lost by not offering the dates view here: the date strip stays
   * on screen in the submission-groups view, so another date is one click away.
   */
  handleBackButtonClicked() {
    console.log('handleBackButtonClicked');
    this.props.root.changeStatus(this.props.parent.STATUS_VIEW_LOCALE());
  }

  handleForwardButtonClicked() {
    if (this.state.status == RET_VIEW_DATES) {
      this.handleDateClicked(this.state.currentDate, false);
    }
  }

  handleRouteClicked() {
    this.refs.submissionDetailMapDialog.setState({ open: true });
  }

  checkTimelineOverflow() {
    if (this.timelineScrollRef.current) {
      const container = this.timelineScrollRef.current;
      const hasOverflow = container.scrollWidth > container.clientWidth;
      const shouldCenter = !hasOverflow;
      this.setState({ 
        showScrollButtons: hasOverflow,
        shouldCenterTimeline: shouldCenter
      });
    }
  }

  scrollTimeline(direction) {
    if (this.timelineScrollRef.current) {
      const container = this.timelineScrollRef.current;
      const scrollAmount = 300;
      const currentScroll = container.scrollLeft;
      const newScroll = direction === 'left' 
        ? Math.max(0, currentScroll - scrollAmount)
        : Math.min(container.scrollWidth - container.clientWidth, currentScroll + scrollAmount);
      
      container.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
      
      this.setState({ timelineScrollLeft: newScroll });
    }
  }

  startContinuousScroll(direction) {
    // Clear any existing interval
    this.stopContinuousScroll();
    
    // Store direction for the interval
    this.setState({ scrollDirection: direction });
    
    // Initial scroll
    this.scrollTimelineContinuous(direction);
    
    // Start continuous scrolling with interval
    const interval = setInterval(() => {
      this.scrollTimelineContinuous(direction);
    }, 100); // Scroll every 100ms for smooth continuous movement
    
    this.setState({ scrollInterval: interval });
  }

  stopContinuousScroll() {
    if (this.state.scrollInterval) {
      clearInterval(this.state.scrollInterval);
      this.setState({ 
        scrollInterval: null,
        scrollDirection: null 
      });
    }
  }

  scrollTimelineContinuous(direction) {
    if (this.timelineScrollRef.current) {
      const container = this.timelineScrollRef.current;
      const scrollAmount = 20; // Smaller amount for smooth continuous scrolling
      const currentScroll = container.scrollLeft;
      const newScroll = direction === 'left' 
        ? Math.max(0, currentScroll - scrollAmount)
        : Math.min(container.scrollWidth - container.clientWidth, currentScroll + scrollAmount);
      
      // Use direct scroll without smooth behavior for continuous scrolling
      container.scrollLeft = newScroll;
      this.setState({ timelineScrollLeft: newScroll });
      
      // Stop scrolling if we've reached the end
      if ((direction === 'left' && newScroll === 0) || 
          (direction === 'right' && newScroll === container.scrollWidth - container.clientWidth)) {
        this.stopContinuousScroll();
      }
    }
  }

  // Drag scrolling handlers
  handleTimelineMouseDown(e) {
    if (!this.timelineScrollRef.current) return;
    
    // Only handle left mouse button
    if (e.button !== 0) return;
    
    // Don't start dragging if clicking on interactive elements
    const target = e.target;
    if (target.tagName === 'BUTTON' || 
        target.closest('button') || 
        target.getAttribute('role') === 'button' ||
        target.closest('[role="button"]')) {
      return;
    }
    
    e.preventDefault();
    
    const container = this.timelineScrollRef.current;
    this.setState({
      isDragging: true,
      dragStartX: e.clientX,
      dragStartScrollLeft: container.scrollLeft
    });
    
    // Add global mouse event listeners
    document.addEventListener('mousemove', this.handleTimelineMouseMove);
    document.addEventListener('mouseup', this.handleTimelineMouseUp);
    
    // Change cursor style
    container.style.cursor = 'grabbing';
  }

  handleTimelineMouseMove(e) {
    if (!this.state.isDragging || !this.timelineScrollRef.current) return;
    
    e.preventDefault();
    
    const container = this.timelineScrollRef.current;
    const deltaX = e.clientX - this.state.dragStartX;
    const newScrollLeft = this.state.dragStartScrollLeft - deltaX;
    
    // Clamp scroll position to valid range
    const maxScroll = container.scrollWidth - container.clientWidth;
    const clampedScroll = Math.max(0, Math.min(maxScroll, newScrollLeft));
    
    container.scrollLeft = clampedScroll;
    this.setState({ timelineScrollLeft: clampedScroll });
  }

  handleTimelineMouseUp(e) {
    if (!this.timelineScrollRef.current) return;
    
    const container = this.timelineScrollRef.current;
    
    this.setState({
      isDragging: false,
      dragStartX: 0,
      dragStartScrollLeft: 0
    });
    
    // Remove global mouse event listeners
    document.removeEventListener('mousemove', this.handleTimelineMouseMove);
    document.removeEventListener('mouseup', this.handleTimelineMouseUp);
    
    // Reset cursor style
    container.style.cursor = 'grab';
  }

  scrollToFilteredDateRange() {
    // Only scroll if there's an active filter
    if (this.state.showAllDates || (!this.state.dateFilterStart && !this.state.dateFilterEnd)) {
      return;
    }

    console.log('Scrolling to filtered date range:', this.state.dateFilterStart, 'to', this.state.dateFilterEnd);

    // Wait for the timeline to render with the highlighting
    setTimeout(() => {
      this.scrollToActualFilteredElement();
    }, 800);
  }

  scrollToActualFilteredElement() {
    if (!this.timelineScrollRef.current) {
      console.log('Timeline ref not available');
      return;
    }

    const container = this.timelineScrollRef.current;
    console.log('Looking for highlighted/filtered elements...');

    // Wait a bit more for the highlighting to fully apply
    setTimeout(() => {
      // Find all elements that have the filtered background color
      const allButtons = container.querySelectorAll('[role="button"]');
      console.log('Found', allButtons.length, 'button elements');
      
      let highlightedElements = [];
      
      // Look for elements with non-default background colors (filtered styling)
      allButtons.forEach((button, index) => {
        const computedStyle = window.getComputedStyle(button);
        const backgroundColor = computedStyle.backgroundColor;
        
        // Check if it has a filtered background color (with alpha/transparency)
        if (backgroundColor && 
            backgroundColor.includes('rgba(') && // has rgba (filtered elements)
            !backgroundColor.includes('rgba(0, 0, 0, 0)') && // not transparent
            backgroundColor.includes('0.8')) { // our filtered elements use 0.8 opacity
          
          console.log('Found highlighted element at index', index, 'with background:', backgroundColor);
          highlightedElements.push({
            element: button,
            index: index,
            backgroundColor: backgroundColor
          });
        }
      });
      
      console.log('Found', highlightedElements.length, 'highlighted elements');
      
      if (highlightedElements.length > 0) {
        // Use the first highlighted element
        const targetElement = highlightedElements[0].element;
        console.log('Scrolling to first highlighted element');
        
        // Use scrollIntoView for the most reliable scrolling
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        
        console.log('scrollIntoView called on highlighted element');
        
        // Also try manual positioning as backup
        setTimeout(() => {
          const elementRect = targetElement.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const elementLeft = elementRect.left - containerRect.left + container.scrollLeft;
          const targetScroll = elementLeft - (container.clientWidth / 2) + (elementRect.width / 2);
          const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
          const finalScroll = Math.max(0, Math.min(maxScroll, targetScroll));
          
          console.log('Backup scroll - Current:', container.scrollLeft, 'Target:', finalScroll);
          
          // If scrollIntoView didn't work well, use manual scroll
          if (Math.abs(container.scrollLeft - finalScroll) > 100) {
            console.log('scrollIntoView was not accurate, using manual scroll');
            container.scrollTo({
              left: finalScroll,
              behavior: 'smooth'
            });
          }
        }, 100);
        
      } else {
        console.log('No highlighted elements found, using fallback method');
        this.scrollToDateRange();
      }
    }, 100); // Extra delay to ensure highlighting is applied
  }

  scrollToDateRange() {
    if (!this.timelineScrollRef.current) {
      console.log('Timeline ref not available');
      return;
    }

    const startDate = this.state.dateFilterStart ? new Date(this.state.dateFilterStart) : null;
    const endDate = this.state.dateFilterEnd ? new Date(this.state.dateFilterEnd) : null;
    
    if (!startDate && !endDate) {
      console.log('No filter dates set');
      return;
    }

    // Find the target date (use start date if available, otherwise end date)
    const targetDate = startDate || endDate;
    console.log('Target date for scrolling:', targetDate);
    
    // Get all dates and find the position
    const allDates = [...this.state.submissionGroupList].sort((a, b) => 
      new Date(a.submission_time) - new Date(b.submission_time)
    );
    
    // Find the index of the target date
    let targetIndex = -1;
    for (let i = 0; i < allDates.length; i++) {
      const itemDate = new Date(allDates[i].submission_time);
      if (startDate && endDate) {
        // If in range, use the first date in range
        if (itemDate >= startDate && itemDate <= endDate) {
          targetIndex = i;
          break;
        }
      } else if (startDate) {
        // Find first date >= start date
        if (itemDate >= startDate) {
          targetIndex = i;
          break;
        }
      } else if (endDate) {
        // Find first date <= end date
        if (itemDate <= endDate) {
          targetIndex = i;
          break;
        }
      }
    }
    
    console.log('Target index:', targetIndex, 'of', allDates.length, 'dates');
    
    if (targetIndex >= 0) {
      const container = this.timelineScrollRef.current;
      
      // Group dates by year to calculate accurate position
      const groups = {};
      allDates.forEach((row) => {
        const d = new Date(row.submission_time);
        const y = d.getFullYear();
        if (!groups[y]) groups[y] = [];
        groups[y].push(row);
      });
      
      const years = Object.keys(groups).sort((a, b) => Number(a) - Number(b));
      
      // Find which year and position within year our target is
      let cumulativeIndex = 0;
      let targetYearIndex = 0;
      let positionInYear = 0;
      
      for (let yearIdx = 0; yearIdx < years.length; yearIdx++) {
        const year = years[yearIdx];
        const yearDates = groups[year];
        
        if (cumulativeIndex + yearDates.length > targetIndex) {
          targetYearIndex = yearIdx;
          positionInYear = targetIndex - cumulativeIndex;
          break;
        }
        cumulativeIndex += yearDates.length;
      }
      
      console.log('Target is in year', years[targetYearIndex], 'at position', positionInYear);
      
      // Estimate scroll position
      // Each year section is roughly 200px wide, each date within year is roughly 80px
      const yearWidth = 200;
      const dateWidth = 80;
      const estimatedPosition = (targetYearIndex * yearWidth) + (positionInYear * dateWidth);
      
      console.log('Estimated position:', estimatedPosition);
      
      // Center the target in the viewport
      const targetScroll = estimatedPosition - (container.clientWidth / 2);
      
      // Ensure we don't scroll beyond bounds
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      const finalScroll = Math.max(0, Math.min(maxScroll, targetScroll));
      
      console.log('Final scroll position:', finalScroll, 'max:', maxScroll);
      
      // Try multiple scroll methods to ensure it works
      try {
        // Method 1: scrollTo with smooth behavior
        container.scrollTo({
          left: finalScroll,
          behavior: 'smooth'
        });
        console.log('Smooth scroll attempted');
      } catch (e) {
        console.log('Smooth scroll failed, trying direct scroll');
        // Method 2: Direct scroll property
        container.scrollLeft = finalScroll;
      }
      
      // Verify the scroll happened and force it if needed
      setTimeout(() => {
        const currentScroll = container.scrollLeft;
        console.log('Current scroll position after scroll attempt:', currentScroll);
        
        // If scroll didn't happen, force it
        if (Math.abs(currentScroll - finalScroll) > 10) {
          console.log('Scroll did not reach target, forcing scroll');
          container.scrollLeft = finalScroll;
          
          // Check again
          setTimeout(() => {
            console.log('Final scroll position after force:', container.scrollLeft);
          }, 100);
        } else {
          console.log('Scroll successful!');
        }
      }, 500);
      
      this.setState({ timelineScrollLeft: finalScroll });
    } else {
      console.log('Target date not found in timeline');
    }
  }

  tidy_ans_batch(answers, scoreBySubmissionId){
    let result = [];
    let component_data = [];
    // The per-submission totals go to their own "Score" sheet. They are built
    // here rather than in download_ans_batch_OK because the parsed tree never
    // leaves this function -- the alternative is JSON.parse-ing a multi-MB
    // response a second time.
    const scoreRows = [];
    try {
      answers = JSON.parse(answers).result;
    } catch (e) {
      console.error('Failed to parse answers for batch export:', e);
      return { answerRows: result, scoreRows };
    }
    if (!answers) {
      console.error('No result in answers for batch export');
      return { answerRows: result, scoreRows };
    }
    const scoreLookup = scoreBySubmissionId || {};
    // console.log('answer:', answers);

    for(let i = 0; i < answers.submission_list.length; i++){
      // A submission deleted between listing and export comes back as an empty
      // shell with a null submission_data; skip it rather than fault the file.
      const submission_data = answers.submission_list[i] && answers.submission_list[i].submission_data;
      if (!submission_data) {
        continue;
      }
      var udid = submission_data.udid;
      var username = submission_data.user_name;
      var submission_id = submission_data.id;
      const userScores = this.getExportUserScores(
        answers.submission_list[i].hotspot_list,
        scoreLookup[String(submission_id)]
      );
      scoreRows.push(buildUserScoreRow({
        username: username,
        udid: udid,
        submissionId: submission_id,
        submissionTime: submission_data.submission_time,
        aiScore: userScores.aiScore,
        aiScoreAll: userScores.aiScoreAll,
        paperScore: userScores.paperScore,
        paperScoreAll: userScores.paperScoreAll,
      }));
      for(let j = 0; j < answers.submission_list[i].hotspot_list.length; j++){
        var hotspot_id = answers.submission_list[i].hotspot_list[j].hotspot_detail.id;
        var hotspot_name = answers.submission_list[i].hotspot_list[j].hotspot_detail.name;
        // console.log(answers.submission_list[i].hotspot_list[j]);
        for(let k = 0; k < answers.submission_list[i].hotspot_list[j].answer_list.length; k++){
          var component_id = answers.submission_list[i].hotspot_list[j].answer_list[k].component_id;
          var component_kind_id = answers.submission_list[i].hotspot_list[j].answer_list[k].kind;
          var component_kind = Config.GET_HOTSPOT_CONTENT_CONFIG(parseInt(component_kind_id)).title;
          var answer = answers.submission_list[i].hotspot_list[j].answer_list[k].answer;
          // Locate matched component to get score_max
          let matched_component = null;
          const compList = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list || [];
          for (let c = 0; c < compList.length; c++) {
            if (compList[c].id === component_id) {
              matched_component = compList[c];
              break;
            }
          }
          // Prepare score export fields
          let componentScoreMax = null;
          if (matched_component && matched_component.score_max !== undefined && matched_component.score_max !== null && matched_component.score_max !== '') {
            const n = parseFloat(matched_component.score_max);
            componentScoreMax = isNaN(n) ? null : n;
          }
          let rawAnswerScore = null;
          if (answers.submission_list[i].hotspot_list[j].answer_list[k].score !== undefined && answers.submission_list[i].hotspot_list[j].answer_list[k].score !== null && answers.submission_list[i].hotspot_list[j].answer_list[k].score !== '') {
            const n = parseFloat(answers.submission_list[i].hotspot_list[j].answer_list[k].score);
            rawAnswerScore = isNaN(n) ? null : n;
          }
          const answerScoreForExport = (rawAnswerScore === null || rawAnswerScore === -1) ? null : rawAnswerScore;
          const canShowScore = (componentScoreMax !== null && !isNaN(componentScoreMax) && componentScoreMax >= 0);
          if((component_kind_id == '11' || component_kind_id == '13' || component_kind_id == '17') && answers.submission_list[i].hotspot_list[j].answer_list[k].path != ''){
            answer = Config.UPLOAD_PATH() + answers.submission_list[i].hotspot_list[j].answer_list[k].path;
          }
          const voiceToText = answers.submission_list[i].hotspot_list[j].answer_list[k].voice_to_text_transcription || '';
          const aiAssessmentResult = answers.submission_list[i].hotspot_list[j].answer_list[k].ai_assessment_result || '';
          const aiAssessmentScore = (() => {
            const match = (aiAssessmentResult || '').match(/<\s*([0-9]+(?:\.[0-9]+)?)\s*[%％]\s*>/);
            return match ? `${match[1]}%` : '';
          })();
          var component_name = '';
          var component_content = '';
          result.push({
            udid: udid,
            username: username,
            submission_id: submission_id,
            hotspot_id: hotspot_id,
            hotspot_name: hotspot_name,
            component_id: component_id,
            component_kind_id: component_kind_id,
            component_kind: component_kind,
            component_name: component_name,
            component_content: component_content,
            answer: answer,
            'Voice to Text Transcription': voiceToText,
            'AI Assessment Result': aiAssessmentResult,
            'AI Assessment Score': aiAssessmentScore,
            answer_score: canShowScore ? answerScoreForExport : '',
            component_score_max: canShowScore ? componentScoreMax : ''
          });
        }

        for(let k = 0; k < answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list.length; k++){
          var component_id = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list[k].id;
          var component_name = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list[k].name;
          var component_content = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list[k].content;

          component_data.push({component_id:component_id, component_name:component_name, component_content:component_content});
        }
      }
    }

    //merge result and conponent_data
    for(let i = 0; i < result.length; i++){
      for(let j = 0; j < component_data.length; j++){
        if(result[i].component_id == component_data[j].component_id){
          //component id matched
          result[i].component_name = component_data[j].component_name;
          result[i].component_content = component_data[j].component_content;
        }
      }
    }

    return { answerRows: result, scoreRows };
  }

  /**
   * The per-submission totals first -- Excel opens onto the first sheet, and the
   * summary is what a teacher wants to land on -- then the answers. The "Score"
   * sheet is skipped entirely when the locale has neither AI assessments nor
   * marks, in which case the file opens onto the answers as it always did.
   */
  appendExportSheets(workbook, exported){
    const answerRows = (exported && exported.answerRows) || [];
    const scoreRows = (exported && exported.scoreRows) || [];
    if (hasAnyUserScore(scoreRows)) {
      workbook.appendSheet(
        XLSX.utils.json_to_sheet(omitEmptyUserScoreColumns(scoreRows)),
        SCORE_SHEET_NAME
      );
    }
    workbook.appendSheet(XLSX.utils.json_to_sheet(answerRows), 'Latest_Submission');
  }

  download_ans_batch_OK(res, filename, scoreBySubmissionId){
    // var file = new File([this.tidy_ans_batch(res.text)], filename, {type: "text/plain;charset=utf-8"});
    const workbook = new Workbook();
    this.appendExportSheets(workbook, this.tidy_ans_batch(res, scoreBySubmissionId));
    saveAs(workbook.toBlob(), filename);
  }

  download_ans_batch_fail(err){
    console.log("download ans batch failed");
  }

  download_ans_batch(filename='test.csv', currentDate, submissionListOverride=null) {
    const requestExport = (submissionIDs, dateParam, submissionsForScores) => {
      if (!submissionIDs || submissionIDs.length === 0) {
        console.log('No submission IDs to export');
        return;
      }
      const dateForApi = dateParam || currentDate || '';
      const scoreBySubmissionId = buildScoreBySubmissionId(submissionsForScores);
      this.props.root.refs.API.request_ans(
        "download_ans_batch",
        filename,
        { 
          school_id: this.props.root.getMySchoolId(), 
          locale_id: this.state.currentLocaleId, 
          date: dateForApi, 
          submission_id_list: submissionIDs
        },
        (res, fname) => this.download_ans_batch_OK(res, fname, scoreBySubmissionId),
        this.download_ans_batch_fail
      );
    };

    // If submissions are already available (e.g., multi-date selection), export directly
    if (submissionListOverride && submissionListOverride.length > 0) {
      const submissionIDList = [...new Set(submissionListOverride.map(item => item.id).filter(Boolean))];
      const fallbackDate = currentDate || (submissionListOverride[0]?.submission_time?.split(' ')[0] ?? '');
      requestExport(submissionIDList, fallbackDate, submissionListOverride);
      return;
    }

    let submissionList = [];
    this.props.root.refs.API.request("get_submission_list_by_epack_and_date", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:currentDate },
      (res)=>{
        submissionList = Array.isArray(res.body['result']) ? res.body['result'] : [];
        let submissionIDList = [];
        for (let i = 0; i < submissionList.length; i++) {
          submissionIDList.push(submissionList[i].id);
        }
        requestExport(submissionIDList, currentDate, submissionList);
      },
      ()=>{
        console.log('retrieve submission_list_by_epack_and_date failed');
      }
    );
  }

  /**
   * The bits every export button needs: the privilege gate, the submissions on
   * screen, and the date suffix that names the file. Returns null (having said
   * why) when there is nothing to export.
   */
  prepareExport() {
    const { submissionList, selectedDates, dateFilterStart, dateFilterEnd, currentDate, actualFilterDate } = this.state;
    const canExport = this.props.root.getPrivilege('ANSWER_EXPORT').value === '1';
    if (!canExport) {
      console.log('Export not allowed by privilege');
      return null;
    }
    if (!submissionList || submissionList.length === 0) {
      console.log('No submissions to export');
      return null;
    }

    const uniqueSubmissionIds = [...new Set(submissionList.map(item => item.id).filter(Boolean))];
    if (uniqueSubmissionIds.length === 0) {
      console.log('No valid submission IDs to export');
      return null;
    }

    const dateOnly = (value) => (value ? value.split(' ')[0] : '');
    let exportLabel = '';

    if (selectedDates && selectedDates.length > 1) {
      const sorted = [...selectedDates].sort((a, b) => new Date(a) - new Date(b));
      exportLabel = `${dateOnly(sorted[0])}_${dateOnly(sorted[sorted.length - 1])}`;
    } else if (dateFilterStart || dateFilterEnd) {
      exportLabel = `${dateFilterStart || 'start'}_${dateFilterEnd || 'end'}`;
    } else if (currentDate) {
      exportLabel = dateOnly(currentDate);
    } else if (actualFilterDate) {
      exportLabel = dateOnly(actualFilterDate);
    } else if (selectedDates && selectedDates.length === 1) {
      exportLabel = dateOnly(selectedDates[0]);
    }

    return {
      submissionList,
      uniqueSubmissionIds,
      exportLabel: exportLabel || 'all',
      apiDate: dateOnly(currentDate) || dateOnly(actualFilterDate) || dateFilterStart || '',
    };
  }

  handleExportAllAnswers() {
    const prepared = this.prepareExport();
    if (!prepared) return;
    const filename = `${this.props.localeData.name}_${prepared.exportLabel}.xlsx`;
    this.download_ans_batch(filename, prepared.apiDate, prepared.submissionList);
  }

  handleExportAiScores() {
    this.exportScoreSheet({
      suffix: 'AI_Score',
      sheetName: AI_SCORE_SHEET_NAME,
      // The button downloads AI Score (all): every assessable question,
      // unanswered ones as 0%. The answered-only average stays on the card.
      buildRows: (entries) => buildAiScoreRows(entries, { scope: 'all' }),
    });
  }

  handleExportMarks() {
    this.exportScoreSheet({
      suffix: 'Marks',
      sheetName: MARKS_SHEET_NAME,
      buildRows: buildMarksRows,
    });
  }

  /**
   * One sheet of per-student, per-hotspot figures. Same submissions and same
   * request as "export all answers" -- only the shaping differs -- so the two
   * files can always be reconciled against each other.
   */
  exportScoreSheet({ suffix, sheetName, buildRows }) {
    const prepared = this.prepareExport();
    if (!prepared) return;

    const filename = `${this.props.localeData.name}_${prepared.exportLabel}_${suffix}.xlsx`;
    const scoreBySubmissionId = buildScoreBySubmissionId(prepared.submissionList);

    this.props.root.refs.API.request_ans(
      "download_ans_batch",
      filename,
      {
        school_id: this.props.root.getMySchoolId(),
        locale_id: this.state.currentLocaleId,
        date: prepared.apiDate,
        submission_id_list: prepared.uniqueSubmissionIds
      },
      (res, fname) => {
        const rows = buildRows(this.extractExportScoreEntries(res, scoreBySubmissionId));
        if (!hasExportableScores(rows)) {
          // Nothing but udid/username/id would reach the file -- say so rather
          // than hand the teacher a sheet that looks broken.
          window.alert(Localization.strings.NO_SCORE_TO_EXPORT || 'No student has a score to export yet');
          return;
        }
        const workbook = new Workbook();
        workbook.appendSheet(XLSX.utils.json_to_sheet(rows), sheetName);
        saveAs(workbook.toBlob(), fname);
      },
      () => console.log(`score export failed: ${suffix}`)
    );
  }

  tidy_ans(answers){
    let result = [];
    let component_data = [];
    // One student, so the "Score" sheet is a single row -- see tidy_ans_batch.
    let scoreRows = [];
    try {
      answers = JSON.parse(answers).result;
    } catch (e) {
      console.error('Failed to parse answers for export:', e);
      return { answerRows: result, scoreRows };
    }
    if (!answers) {
      console.error('No result in answers for export');
      return { answerRows: result, scoreRows };
    }
    console.log('answer:', answers);
  
    // A deleted submission comes back as an empty shell (null submission_data)
    // with an empty hotspot_list, so the loops below simply find nothing.
    const submission_data = answers.submission_data || {};
    var udid = submission_data.udid;
    var username = submission_data.user_name;
    var submission_id = submission_data.id;
    const userScores = this.getExportUserScores(
      answers.hotspot_list,
      buildScoreBySubmissionId(this.state.submissionList)[String(submission_id)]
    );
    scoreRows = [buildUserScoreRow({
      username: username,
      udid: udid,
      submissionId: submission_id,
      submissionTime: submission_data.submission_time,
      aiScore: userScores.aiScore,
      aiScoreAll: userScores.aiScoreAll,
      paperScore: userScores.paperScore,
      paperScoreAll: userScores.paperScoreAll,
    })];
    for(let j = 0; j < answers.hotspot_list.length; j++){
      var hotspot_id = answers.hotspot_list[j].hotspot_detail.id;
      var hotspot_name = answers.hotspot_list[j].hotspot_detail.name;
        for(let k = 0; k < answers.hotspot_list[j].answer_list.length; k++){
        var component_id = answers.hotspot_list[j].answer_list[k].component_id;
        
        // Find the matching component in component_list by component_id
        var component_kind_id = '';
        var component_kind = '';
        var component_found = false;
        var matched_component = null;
        for(let c = 0; c < answers.hotspot_list[j].hotspot_detail.component_list.length; c++) {
          if(answers.hotspot_list[j].hotspot_detail.component_list[c].id === component_id) {
            matched_component = answers.hotspot_list[j].hotspot_detail.component_list[c];
            component_kind_id = matched_component.kind;
            component_kind = Config.GET_HOTSPOT_CONTENT_CONFIG(parseInt(component_kind_id)).title;
            component_found = true;
            break;
          }
        }
        
        // If component not found, use the answer's kind (fallback)
        if(!component_found && answers.hotspot_list[j].answer_list[k].kind) {
          component_kind_id = answers.hotspot_list[j].answer_list[k].kind;
          component_kind = Config.GET_HOTSPOT_CONTENT_CONFIG(parseInt(component_kind_id)).title;
        }

        var answer = answers.hotspot_list[j].answer_list[k].answer;
        // Prepare score export fields (answer and component)
        let componentScoreMax = null;
        if (matched_component && matched_component.score_max !== undefined && matched_component.score_max !== null && matched_component.score_max !== '') {
          const nMax = parseFloat(matched_component.score_max);
          componentScoreMax = isNaN(nMax) ? null : nMax;
        }
        let rawAnswerScore = null;
        if (answers.hotspot_list[j].answer_list[k].score !== undefined && answers.hotspot_list[j].answer_list[k].score !== null && answers.hotspot_list[j].answer_list[k].score !== '') {
          const nAns = parseFloat(answers.hotspot_list[j].answer_list[k].score);
          rawAnswerScore = isNaN(nAns) ? null : nAns;
        }
        const answerScoreForExport = (rawAnswerScore === null || rawAnswerScore === -1) ? null : rawAnswerScore;
        const canShowScore = (componentScoreMax !== null && !isNaN(componentScoreMax) && componentScoreMax >= 0);
        
        // Special handling for multiple choice (kind 4)
        if(component_kind_id == '4' && matched_component) {
          try {
            const payload = JSON.parse(matched_component.payload);
            // Handle empty answers
            if(answer === "") {
              answer = "(No selection)";
            }
            // Handle single selection
            else {
              const answerIndex = parseInt(answer);
              if(!isNaN(answerIndex) && payload[`ans${answerIndex}`]) {
                answer = payload[`ans${answerIndex}`]; // Replace index with actual answer text
              }
            }
          } catch(e) {
            console.error('Error parsing multiple choice payload:', e);
          }
        }
        // Special handling for multiple choice selection (kind 6 and 7)
        else if((component_kind_id == '6' || component_kind_id == '7') && matched_component) {
          try {
            const payload = JSON.parse(matched_component.payload);
            let selectedOptions = [];
            
            // For each possible answer option (ans0, ans1, ans2, ans3) check if it's selected
            for(let i = 0; i < 10; i++) { // assuming max 10 options
              if(payload[`correct${i}`] === true && payload[`ans${i}`]) {
                selectedOptions.push(payload[`ans${i}`]);
              }
            }
            
            if(selectedOptions.length > 0) {
              answer = selectedOptions.join("; ");
            } else {
              answer = "(No selection)";
            }
          } catch(e) {
            console.error('Error parsing multiple selection payload:', e);
          }
        }
        // Special handling for images, audio, and drawings
        else if((component_kind_id == '11' || component_kind_id == '13' || component_kind_id == '17') && answers.hotspot_list[j].answer_list[k].path != ''){
          answer = Config.UPLOAD_PATH() + answers.hotspot_list[j].answer_list[k].path;
        }
        
        const voiceToText = answers.hotspot_list[j].answer_list[k].voice_to_text_transcription || '';
        const aiAssessmentResult = answers.hotspot_list[j].answer_list[k].ai_assessment_result || '';
        const aiAssessmentScore = (() => {
          const match = (aiAssessmentResult || '').match(/<\s*([0-9]+(?:\.[0-9]+)?)\s*[%％]\s*>/);
          return match ? `${match[1]}%` : '';
        })();
        var component_name = '';
        var component_content = '';
        result.push({
          udid: udid,
          username: username,
          submission_id: submission_id,
          hotspot_id: hotspot_id,
          hotspot_name: hotspot_name,
          component_id: component_id,
          component_kind_id: component_kind_id,
          component_kind: component_kind,
          component_name: component_name,
          component_content: component_content,
          answer: answer,
          'Voice to Text Transcription': voiceToText,
          'AI Assessment Result': aiAssessmentResult,
          'AI Assessment Score': aiAssessmentScore,
          answer_score: canShowScore ? answerScoreForExport : '',
          component_score_max: canShowScore ? componentScoreMax : ''
        });
      }

      for(let k = 0; k < answers.hotspot_list[j].hotspot_detail.component_list.length; k++){
        var component_id = answers.hotspot_list[j].hotspot_detail.component_list[k].id;
        var component_name = answers.hotspot_list[j].hotspot_detail.component_list[k].name;
        var component_content = answers.hotspot_list[j].hotspot_detail.component_list[k].content;

        component_data.push({component_id:component_id, component_name:component_name, component_content:component_content});
      }
    }

    //merge result and conponent_data
    for(let i = 0; i < result.length; i++){
      for(let j = 0; j < component_data.length; j++){
        if(result[i].component_id == component_data[j].component_id){
          //component id matched
          result[i].component_name = component_data[j].component_name;
          result[i].component_content = component_data[j].component_content;
        }
      }
    }

    return { answerRows: result, scoreRows };
  }

  download_ans_OK(res, filename){
    // console.log('download ans ok:', res);
    const workbook = new Workbook();
    this.appendExportSheets(workbook, this.tidy_ans(res));
    saveAs(workbook.toBlob(), filename);
  }

  download_ans_fail(err){
    console.log('download ans failed');
  }

  download_ans(filename='test.csv', submission_id){
    this.props.root.refs.API.request_ans("download_ans", filename, {submission_id:submission_id}, this.download_ans_OK, this.download_ans_fail);
  }

  checkSharable(submissionId) {
    this.props.root.refs.API.request("is_submission_sharable", { submission_id: submissionId }, this.isSubmissionSharableOK, () => {});
  }

  isSubmissionSharableOK(res) {
    if (res.body.result) {
      this.setState({
        isSharable: res.body.result.is_sharable,
        shareToken: res.body.result.token,
      }, () => {
        if (this.retrieverBarRef.current) {
          this.retrieverBarRef.current.setState({
            isSharable: res.body.result.is_sharable,
            showShareButton: true 
          });
        }
      });
    }
  }

  handleShareClick() {
    if (this.state.isSharable === 1) {
      const url = Config.SHARING_URL() + this.state.shareToken;
      this.setState({ sharingUrl: url, shareDialogOpen: true });
    } else {
      this.setState({ shareDialogOpen: true });
    }
  }

  handleShareDialogClose() {
    this.setState({ shareDialogOpen: false, sharingUrl: '', showCopyMessage: false });
  }

  handleCopyUrl() {
    if (this.state.sharingUrl) {
      navigator.clipboard.writeText(this.state.sharingUrl).then(() => {
        this.setState({ showCopyMessage: true });
        // Hide message after 3 seconds
        setTimeout(() => {
          this.setState({ showCopyMessage: false });
        }, 3000);
      });
    }
  }

  handleCopyButton() {
    if (this.state.sharingUrl) {
      navigator.clipboard.writeText(this.state.sharingUrl);
    }
  }

  handleConfirmShare() {
    this.props.root.refs.API.request(
      "share_submission",
      {
        school_id: this.props.root.getMySchoolId(),
        submission_id: this.state.currentSubmissionId,
      },
      (res) => { // OK
        if (res.body.result && res.body.result.success) {
          const token = res.body.result.token;
          const url = Config.SHARING_URL() + token;
          this.setState({
            isSharable: 1,
            shareToken: token,
            sharingUrl: url,
          });
          if (this.retrieverBarRef.current) {
            this.retrieverBarRef.current.setState({ isSharable: 1 });
          }
        } else {
          // Handle error from API
          console.error("Failed to share submission:", res.body.result && res.body.result.error);
          this.handleShareDialogClose();
        }
      },
      (err) => { // Fail
        console.error("API call to share_submission failed:", err);
        this.handleShareDialogClose();
      }
    );
  }

  handleDateFilterStart(date) {
    this.setState({ 
      tempDateFilterStart: date
    });
  }

  handleDateFilterEnd(date) {
    this.setState({ 
      tempDateFilterEnd: date
    });
  }

  handleConfirmDateFilter() {
    // If 'To' date is empty, default to today's date
    let effectiveEndDate = this.state.tempDateFilterEnd;
    if (this.state.tempDateFilterStart && !this.state.tempDateFilterEnd) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      effectiveEndDate = `${year}-${month}-${day}`;
      
      console.log('DEBUG: No "To" date provided, defaulting to today:', effectiveEndDate);
    }
    
    this.setState({
      dateFilterStart: this.state.tempDateFilterStart,
      dateFilterEnd: effectiveEndDate,
      tempDateFilterEnd: effectiveEndDate, // Update temp value to reflect the default
      showAllDates: (!this.state.tempDateFilterStart && !effectiveEndDate),
      currentDate: "", // Clear single date selection when applying filter
      selectedIndex: -1, // Reset selected submission index
      actualFilterDate: null // Reset actual filter date
    }, () => {
      // Reload submission data for the selected date range
      this.loadSubmissionDataForDateRange();
      // Scroll timeline to show the filtered date range
      this.scrollToFilteredDateRange();
    });
  }

    handleClearDateFilter() {
      this.setState({
        dateFilterStart: '',
        dateFilterEnd: '',
        tempDateFilterStart: '',
        tempDateFilterEnd: '',
        showAllDates: true,
        actualFilterDate: null,
        submissionList: [], // Clear the filtered submission data
        sortedSubmissionList: [],
        currentDate: "",    // Clear any selected single date
        selectedDates: [],  // Clear selected dates to remove timeline highlighting
        selectedIndex: -1   // Reset selected submission index
      }, () => {
        // Clear direct state assignments for selected dates to remove highlighting
        this.state.currentDate = "";
        this.state.selectedDates = [];
        this.state.selectedIndex = -1;
        this.state.sortedSubmissionList = [];
        
        // Note: We keep submissionGroupList (timeline data) intact and stay in current view
        // Only clear the highlighting and submission data
        console.log('DEBUG: Filter cleared, date highlighting removed, timeline data preserved');
      });
    }

  loadSubmissionDataForDateRange() {
    // If there's a current single date selected, use that instead of filter
    if (this.state.currentDate) {
      this.refreshSubmissionDataForCurrentDate();
      return;
    }

    // If showing all dates or no filter active, clear submissions
    if (this.state.showAllDates || (!this.state.dateFilterStart && !this.state.dateFilterEnd)) {
      this.clearSubmissionListState();
      return;
    }

    // Get all dates in the selected range
    // Calendar-day comparison — see dayOf().
    const startDate = this.dayOf(this.state.dateFilterStart);
    const endDate = this.dayOf(this.state.dateFilterEnd);

    const datesInRange = this.state.submissionGroupList.filter(row => {
      const submissionDate = this.dayOf(row.submission_time);

      if (startDate && endDate) {
        return submissionDate >= startDate && submissionDate <= endDate;
      } else if (startDate) {
        return submissionDate >= startDate;
      } else if (endDate) {
        return submissionDate <= endDate;
      }

      return false;
    });

    // Load submissions for all dates in range
    if (datesInRange.length > 0) {
      this.loadSubmissionsForMultipleDates(datesInRange);
    } else {
      this.clearSubmissionListState();
    }
  }

  refreshSubmissionDataForCurrentDate() {
    if (this.state.currentDate) {
      this.props.root.refs.API.request("get_submission_list_by_epack_and_date", 
        { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date: this.state.currentDate }, 
        this.getSubmissionGroupByDateOK, 
        this.getSubmissionGroupByDateFailed
      );
    }
  }


  getFilteredSubmissionGroups() {
    // Timeline always shows all dates - no filtering
    return this.state.submissionGroupList;
  }

  isDateInFilterRange(dateStr) {
    // Check if a date falls within the current filter range
    if (this.state.showAllDates || (!this.state.dateFilterStart && !this.state.dateFilterEnd)) {
      return false; // No highlighting when showing all dates or no filter active
    }

    // Don't highlight filtered dates if there's a current single date selected
    if (this.state.currentDate) {
      return false; // Single date mode takes precedence
    }

    // Calendar-day comparison — see dayOf().
    const date = this.dayOf(dateStr);
    const startDate = this.dayOf(this.state.dateFilterStart);
    const endDate = this.dayOf(this.state.dateFilterEnd);

    if (startDate && endDate) {
      return date >= startDate && date <= endDate;
    } else if (startDate) {
      return date >= startDate;
    } else if (endDate) {
      return date <= endDate;
    }

    return false;
  }


  render() {
        //If the description is too long, break down the word
    let paragraph = "";
    for (var i=0;i<this.props.localeData['name'].length;i++){
    if(i%40 == 0 && window.screen.width >= 1024){
      paragraph = paragraph + "\n" ;
    }

    if(i%10 == 0 && window.screen.width < 1024){
      paragraph = paragraph + "\n" ;
      }
      paragraph = paragraph + this.props.localeData['name'][i];
    }
        //
        
    return (
      <div>
        <SubmissionDetailMapDialog root={this.props.root} parent={this} ref="submissionDetailMapDialog"/>
        <RetrieverBar root={this.props.root} parent={this} ref={this.retrieverBarRef} onShareClick={this.handleShareClick} />
        <Dialog open={this.state.shareDialogOpen} onClose={this.handleShareDialogClose} fullWidth={true} maxWidth={'sm'}>
          <DialogTitle style={{
            backgroundColor: this.props.theme.palette.primary.main,
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingRight: '16px'
          }}>
            <span>
              {this.state.isSharable ? Localization.strings.SHARING_URL : Localization.strings.CONFIRM_SHARE_SUBMISSION}
            </span>
            <IconButton
              onClick={this.handleShareDialogClose}
              style={{ color: 'white', padding: '4px' }}
            >
              <Icon>close</Icon>
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ paddingTop: '20px' }}>
            {this.state.sharingUrl ? (
              <Box display="flex" flexDirection="column">
                <Box display="flex" alignItems="center" width="100%">
                  <TextField
                    autoFocus
                    margin="dense"
                    id="sharing-url"
                    label={Localization.strings.SHARING_URL}
                    type="text"
                    fullWidth
                    variant="standard"
                    value={this.state.sharingUrl}
                    InputProps={{
                      readOnly: true,
                      style: { cursor: 'pointer' }
                    }}
                    onClick={this.handleCopyUrl}
                  />
                  <Button 
                    variant="contained" 
                    color="primary" 
                    style={{ marginLeft: '10px', minWidth: '80px', height: '36px', alignSelf: 'flex-end', marginBottom: '4px' }}
                    onClick={this.handleCopyButton}
                  >
                    {Localization.strings.COPY}
                  </Button>
                </Box>
                {this.state.showCopyMessage && (
                  <Typography variant="caption" color="primary" style={{ marginTop: '4px' }}>
                    {Localization.strings.COPIED_TO_CLIPBOARD}
                  </Typography>
                )}
              </Box>
            ) : (
              <DialogContentText>
                {Localization.strings.SHARE_SUBMISSION_CONFIRM_MESSAGE}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            {this.state.sharingUrl ? (
              <Button onClick={this.handleShareDialogClose}>{Localization.strings.CLOSE}</Button>
            ) : (
              <>
                <Button onClick={this.handleShareDialogClose}>{Localization.strings.CANCEL}</Button>
                <Button onClick={this.handleConfirmShare} color="primary">{Localization.strings.YES}</Button>
              </>
            )}
          </DialogActions>
        </Dialog>
        <Grid container>
          {this.state.status === RET_VIEW_SUBMISSION_GROUPS && this.state.submissionGroupList && this.state.submissionGroupList.length > 0 && (
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ marginTop: '44px', paddingTop: '12px', marginRight: '24px', width: '100%', display: 'flex', justifyContent: 'center', position: 'relative' }}>
 
                {/* Left scroll button */}
                {this.state.showScrollButtons && (
                  <IconButton
                    onClick={() => this.scrollTimeline('left')}
                    onMouseDown={() => this.startContinuousScroll('left')}
                    onMouseUp={() => this.stopContinuousScroll()}
                    onMouseLeave={() => this.stopContinuousScroll()}
                    onTouchStart={() => this.startContinuousScroll('left')}
                    onTouchEnd={() => this.stopContinuousScroll()}
                    style={{
                      position: 'absolute',
                      left: '2%',
                      top: '48%',
                      transform: 'translateY(-50%)',
                      zIndex: 10,
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      width: '40px',
                      height: '40px'
                    }}
                  >
                    <Icon>chevron_left</Icon>
                  </IconButton>
                )}
                
                {/* Right scroll button */}
                {this.state.showScrollButtons && (
                  <IconButton
                    onClick={() => this.scrollTimeline('right')}
                    onMouseDown={() => this.startContinuousScroll('right')}
                    onMouseUp={() => this.stopContinuousScroll()}
                    onMouseLeave={() => this.stopContinuousScroll()}
                    onTouchStart={() => this.startContinuousScroll('right')}
                    onTouchEnd={() => this.stopContinuousScroll()}
                    style={{
                      position: 'absolute',
                      right: '2%',
                      top: '48%',
                      transform: 'translateY(-50%)',
                      zIndex: 10,
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      width: '40px',
                      height: '40px'
                    }}
                  >
                    <Icon>chevron_right</Icon>
                  </IconButton>
                )}
                {/* Visible base line behind timeline */}
                <div
                  style={{
                    position: 'absolute',
                    top: '77px',
                    left: '1%',
                    right: '1%',
                    height: '8px',
                    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #f5576c 75%, #4facfe 100%)',
                    borderRadius: '9999px',
                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                    zIndex: 1,
                    pointerEvents: 'none'
                  }}
                />
                <Timeline
                  ref={this.timelineScrollRef}
                  sx={{
                    m: 0,
                    p: 0,
                    minHeight: '120px',
                    '&.MuiTimeline-root': { padding: 0 },
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: this.state.shouldCenterTimeline ? 'center' : 'flex-start',
                    overflowX: 'auto',
                    alignItems: 'flex-start',
                    position: 'relative',
                    zIndex: 2,
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                    '& .MuiTimelineItem-root': { width: 'auto', position: 'relative', padding: 0, minWidth: 'auto', flexShrink: 0 },
                    '& .MuiTimelineSeparator-root': { display: 'flex', alignItems: 'center' },
                    '& .MuiTimelineItem-missingOppositeContent:before': { display: 'none' },
                    '& .MuiTimelineConnector-root': { height: '12px', width: '120px', backgroundColor: 'transparent', borderRadius: '9999px' },
                    '& .MuiTimelineContent-root': { padding: '4px 8px', flex: '0 0 auto' },
                    '& .MuiTimelineItem-root:not(:last-child)': { marginRight: '16px' },
                  }}
                >
                  {(() => {
                    // Group by year - always show all data
                    const allData = this.getFilteredSubmissionGroups();
                    
                    // If no data at all, show empty timeline with baseline only
                    if (allData.length === 0) {
                      return null;
                    }

                    const sorted = [...allData].sort((a, b) => new Date(a.submission_time) - new Date(b.submission_time));
                    const groups = {};
                    sorted.forEach((row) => {
                      const d = new Date(row.submission_time);
                      const y = d.getFullYear();
                      if (!groups[y]) groups[y] = [];
                      groups[y].push(row);
                    });

                    const years = Object.keys(groups).sort((a, b) => Number(a) - Number(b));
                    const paletteKeys = ['primary', 'secondary', 'success', 'info', 'warning', 'error'];

                    const items = [];
                    years.forEach((year, yearIdx) => {
                      const paletteKey = paletteKeys[yearIdx % paletteKeys.length];
                      const paletteColor = (this.props.theme && this.props.theme.palette && this.props.theme.palette[paletteKey] && this.props.theme.palette[paletteKey].main)
                        ? this.props.theme.palette[paletteKey].main
                        : (this.props.theme.palette.primary ? this.props.theme.palette.primary.main : '#1976d2');
                      const yearOffsetPx = 6;

                      items.push(
                        <TimelineItem key={'year_' + year}>
                          <TimelineSeparator>
                            {yearIdx < years.length - 1 && (
                              <TimelineConnector sx={{ backgroundColor: paletteColor, height: '12px', width: '120px', borderRadius: '9999px' }} />
                            )}
                          </TimelineSeparator>
                          <TimelineContent>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: '160px', marginRight: '24px' }}>
                              <Typography variant="h6" style={{ whiteSpace: 'nowrap', fontWeight: 700, margin: 0, padding: '6px 16px', position: 'relative', top: '0px', backgroundColor: '#ffffff', borderRadius: '8px', zIndex: 30, lineHeight: 1, color: '#000', boxShadow: '0 4px 8px rgba(0,0,0,0.15)', border: '1px solid #e0e0e0' }}>
                                {year}
                              </Typography>
                              <div style={{ width: '2px', height: '14px', backgroundColor: grey[700], margin: '0 0 6px 16px' }} />
                              <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: paletteColor, boxShadow: '0 0 0 2px #ffffff', margin: '0 0 6px 7px' }} />
                              <div style={{ width: '2px', height: '14px', backgroundColor: grey[700], margin: '0 0 6px 16px' }} />
                              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '4px' }}>
                                {groups[year].map((row, idx) => {
                                  const dateStr = row['submission_time'];
                                  const isSelected = this.state.currentDate === dateStr || this.state.selectedDates.includes(dateStr);
                                  const isInFilterRange = this.isDateInFilterRange(dateStr);
                                  const d = new Date(dateStr);
                                  const dd = String(d.getDate()).padStart(2, '0');
                                  const mm = String(d.getMonth() + 1).padStart(2, '0');
                                  const ddmm = `${mm}/${dd}`;
                                  const tooltip = `${dateStr.split(' ')[0]}\n${Localization.strings.SUBMISSION_S}: ${row['count']}\n${Localization.strings.SUBMISSION_P}: ${row['count_u']}`;
                                  
                                  // Determine background color based on state
                                  let backgroundColor = grey[50];
                                  let textColor = 'inherit';
                                  let borderColor = paletteColor;
                                  let elevation = 1;
                                  let borderRadius = '8px';
                                  
                                  if (isSelected) {
                                    // Check if this is part of a range selection
                                    const selectedDates = this.state.selectedDates;
                                    const isRangeSelection = selectedDates.length > 1;
                                    
                                    if (isRangeSelection) {
                                      // Sort selected dates to determine position in range
                                      const sortedDates = [...selectedDates].sort((a, b) => new Date(a) - new Date(b));
                                      const isFirstInRange = sortedDates[0] === dateStr;
                                      const isLastInRange = sortedDates[sortedDates.length - 1] === dateStr;
                                      const isMiddleInRange = !isFirstInRange && !isLastInRange;
                                      
                                      // Range selection styling - darker like clicked dates
                                      backgroundColor = `${paletteColor}CC`; // Dark background like clicked dates
                                      textColor = '#ffffff';
                                      elevation = 5;
                                      
                                      // Adjust border radius for range appearance
                                      if (isFirstInRange) {
                                        borderRadius = '8px 4px 4px 8px'; // Rounded left, square right
                                      } else if (isLastInRange) {
                                        borderRadius = '4px 8px 8px 4px'; // Square left, rounded right
                                      } else if (isMiddleInRange) {
                                        borderRadius = '4px'; // Square on both sides
                                      }
                                      
                                      // Highlight current date in range
                                      if (dateStr === this.state.currentDate) {
                                        backgroundColor = paletteColor; // Full color for current date
                                        elevation = 6;
                                      }
                                    } else {
                                      // Single date selection
                                      backgroundColor = paletteColor;
                                      textColor = '#ffffff';
                                      elevation = 6;
                                    }
                                  } else if (isInFilterRange) {
                                    // Date in filter range - very dark background, almost like clicked date
                                    backgroundColor = `${paletteColor}CC`; // 80% opacity (much darker)
                                    textColor = '#ffffff'; // White text for better contrast
                                    borderColor = paletteColor;
                                    elevation = 5; // Higher elevation for more prominence
                                  }
                                  
                                  return (
                                    <div key={dateStr + '_' + idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                      <div style={{ width: '2px', height: '16px', backgroundColor: grey[700], margin: '-6px 0 8px 0' }} />
                                      <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>} arrow>
                                        <Paper
                                          elevation={elevation}
                                          onClick={(e) => this.handleDateClicked(dateStr, true, e.ctrlKey || e.metaKey)}
                                          role="button"
                                          aria-selected={isSelected}
                                          sx={{
                                            cursor: 'pointer',
                                            padding: '6px 12px',
                                            backgroundColor: backgroundColor,
                                            color: textColor,
                                            borderRadius: borderRadius,
                                            border: `1px solid ${borderColor}`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            transition: 'all 120ms ease',
                                            '&:hover': { 
                                              boxShadow: 6, 
                                              transform: 'translateY(-1px)', 
                                              backgroundColor: isSelected ? paletteColor : (isInFilterRange ? `${paletteColor}E6` : grey[100])
                                            }
                                          }}
                                        >
                                          <Typography style={{ fontSize: '1rem', fontWeight: 700 }}>{ddmm}</Typography>
                                        </Paper>
                                      </Tooltip>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      );
                    });
                    return items;
                  })()}
                </Timeline>
              </div>
            </Grid>
          )}
          <Grid item xs={8} sm={3}>
            <Switch condition={this.state.status}>
              <Case value={RET_VIEW_DATES}>
                <List style={{height: 'auto', minHeight: '200px', maxHeight: '100%', overflow: 'visible', padding: '0'}}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{paragraph}</Typography>
                    </ListItemText>
                  </ListItem>
                  
                  {/* Date Filter for list view - Only show when there are submissions */}
                  {this.state.submissionGroupList.length > 0 && (
                    <ListItem>
                      <Box
                        style={{
                          width: '100%',
                          backgroundColor: this.props.theme.palette.action?.hover || '#f5f5f5',
                          border: `1px solid ${this.props.theme.palette.divider || '#e0e0e0'}`,
                          borderRadius: '8px',
                          padding: '12px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px'
                        }}
                      >
                        <Typography 
                          variant="caption" 
                          style={{ 
                            fontWeight: 'bold',
                            color: this.props.theme.palette.text.primary || 'inherit'
                          }}
                        >
                          Filter by Date Range:
                        </Typography>
                      
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <TextField
                          type="date"
                          label="From"
                          size="small"
                          value={this.state.tempDateFilterStart}
                          onChange={(e) => this.handleDateFilterStart(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          sx={{ 
                            minWidth: '140px', 
                            flex: 1,
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: this.props.theme.palette.primary.main,
                              },
                              '&:hover fieldset': {
                                borderColor: this.props.theme.palette.primary.main,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: this.props.theme.palette.primary.main,
                              },
                            },
                            '& .MuiInputLabel-root': {
                              color: this.props.theme.palette.primary.main,
                              '&.Mui-focused': {
                                color: this.props.theme.palette.primary.main,
                              },
                            },
                          }}
                        />
                        
                        <TextField
                          type="date"
                          label="To"
                          size="small"
                          value={this.state.tempDateFilterEnd}
                          onChange={(e) => this.handleDateFilterEnd(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          sx={{ 
                            minWidth: '140px', 
                            flex: 1,
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: this.props.theme.palette.primary.main,
                              },
                              '&:hover fieldset': {
                                borderColor: this.props.theme.palette.primary.main,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: this.props.theme.palette.primary.main,
                              },
                            },
                            '& .MuiInputLabel-root': {
                              color: this.props.theme.palette.primary.main,
                              '&.Mui-focused': {
                                color: this.props.theme.palette.primary.main,
                              },
                            },
                          }}
                        />
                        
                        <Button
                          size="small"
                          variant="contained"
                          onClick={this.handleConfirmDateFilter}
                          sx={{
                            backgroundColor: this.props.theme.palette.primary.main,
                            color: this.props.theme.palette.primary.contrastText || 'white',
                            '&:hover': {
                              backgroundColor: this.props.theme.palette.primary.dark || this.props.theme.palette.primary.main,
                              transform: 'translateY(-1px)',
                              boxShadow: this.props.theme.shadows ? this.props.theme.shadows[4] : '0 4px 8px rgba(0,0,0,0.2)'
                            }
                          }}
                        >
                          Confirm
                        </Button>
                        
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={this.handleClearDateFilter}
                          sx={{
                            borderColor: this.props.theme.palette.secondary.main,
                            color: this.props.theme.palette.secondary.main,
                            '&:hover': {
                              backgroundColor: this.props.theme.palette.secondary.main,
                              color: this.props.theme.palette.secondary.contrastText || 'white',
                              transform: 'translateY(-1px)',
                              boxShadow: this.props.theme.shadows ? this.props.theme.shadows[2] : '0 2px 4px rgba(0,0,0,0.1)'
                            }
                          }}
                        >
                          Clear
                        </Button>
                      </div>
                    </Box>
                  </ListItem>
                  )}
                  
                  <Divider variant="middle" />
                  <If condition={this.state.submissionGroupList.length == 0}>
                    <Then>
                      <Card style={{margin: "10px",bottom:'10px'}}>
                        <CardContent>
                          {Localization.strings.EMPTY_SUBMISSION_REMINDER}
                        </CardContent>
                      </Card>
                    </Then>
                    <Else>
                      {this.state.submissionGroupList.map( (row, i) => {
                        const dateStr = row['submission_time'];
                        const isSelected = this.state.currentDate === dateStr || this.state.selectedDates.includes(dateStr);
                        const isInFilterRange = this.isDateInFilterRange(dateStr);
                        
                        // Get the year's palette color (same logic as timeline)
                        const d = new Date(dateStr);
                        const year = d.getFullYear();
                        const paletteKeys = ['primary', 'secondary', 'success', 'info', 'warning', 'error'];
                        const yearIndex = Object.keys(this.state.submissionGroupList.reduce((acc, item) => {
                          const itemYear = new Date(item.submission_time).getFullYear();
                          acc[itemYear] = true;
                          return acc;
                        }, {})).sort((a, b) => Number(a) - Number(b)).indexOf(year.toString());
                        const paletteKey = paletteKeys[yearIndex % paletteKeys.length];
                        const yearPaletteColor = (this.props.theme && this.props.theme.palette && this.props.theme.palette[paletteKey] && this.props.theme.palette[paletteKey].main)
                          ? this.props.theme.palette[paletteKey].main
                          : (this.props.theme.palette.primary ? this.props.theme.palette.primary.main : '#1976d2');
                        
                        // Determine styling based on state
                        let borderColor = "#9e9e9e";
                        let backgroundColor = "transparent";
                        let textColor = 'inherit';
                        
                        if (isSelected) {
                          // Current selected date - use year's palette color with darker background
                          borderColor = yearPaletteColor;
                          backgroundColor = `${yearPaletteColor}CC`; // Much darker like clicked dates (80% opacity)
                          textColor = '#ffffff'; // White text for dark background
                        } else if (isInFilterRange) {
                          // Date in filter range - much darker background, very similar to clicked
                          borderColor = yearPaletteColor;
                          backgroundColor = `${yearPaletteColor}40`; // 25% opacity (much darker)
                        }
                        
                        return (
                          <div key={i}>
                          <ListItem button style={{
                            border: `2px solid ${borderColor}`,
                            backgroundColor: backgroundColor,
                            color: textColor,
                            margin:"5px 2px 5px 2px",
                            width:"92%",
                            left:'3.5%',
                            transition: 'all 120ms ease'
                          }}
                          onClick={(e)=>this.handleDateClicked(row['submission_time'], true, e.ctrlKey || e.metaKey)}>
                            <ListItemIcon>
                              <Icon style={{ color: isSelected ? '#ffffff' : (isInFilterRange ? yearPaletteColor : 'inherit') }}>today</Icon>
                            </ListItemIcon>
                            <ListItemText
                              primary={row['submission_time'].split(" ")[0]}
                              secondary={Localization.strings.SUBMISSION_S + ": " + row['count'] + '    '
                                + Localization.strings.SUBMISSION_P + ": " + row['count_u']}
                              primaryTypographyProps={{
                                style: { 
                                  color: isSelected || isInFilterRange ? yearPaletteColor : 'inherit',
                                  fontWeight: isSelected || isInFilterRange ? 600 : 'normal'
                                }
                              }}
                            />
                            <ListItemSecondaryAction>
                              {(() => {
                                // Check privilege for ANSWER_EXPORT permission
                                const canExport = this.props.root.getPrivilege('ANSWER_EXPORT').value === '1';
                                const tooltipTitle = canExport ? Localization.strings.ARCHIVE : Localization.strings.UPGRADE_TO_PREMIUM;
                                return (
                                  <Tooltip title={tooltipTitle}>
                                    <span> {/* Span is needed for Tooltip when IconButton is disabled */} 
                                      <IconButton 
                                        onClick={() => this.download_ans_batch(this.props.localeData['name'] + '_' + row['submission_time'] + '.xlsx', row['submission_time'])} 
                                        disabled={!canExport}
                                      >
                                        <Icon style={{ color: grey[600] }}>archive</Icon>
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                );
                              })()}
                              {/*
                              <Tooltip title={Localization.strings.SHARE}>
                                <IconButton>
                                  <Icon style={{ color: grey[600] }}>share</Icon>
                                </IconButton>
                              </Tooltip>
                              */}
                            </ListItemSecondaryAction>
                          </ListItem>
                          {/*
                          <Card variant="outlined" className="margin-std padding-sm" >
                            <CardContent className="padding-zero">
                              <ListItem button key={i} onClick={()=>this.handleDateClicked(row['submission_time'])}>
                                <ListItemIcon>
                                  <Icon>today</Icon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={row['submission_time'].split(" ")[0]}
                                  secondary={Localization.strings.SUBMISSION_S + ": " + row['count']}
                                />
                                <ListItemSecondaryAction>
                                  <Tooltip title={Localization.strings.DOWNLOAD}>
                                    <IconButton
                                      onClick={()=>this.download_ans_batch(this.props.localeData['name'] + '_' + row['submission_time'] + '.csv')}
                                    >
                                      <Icon style={{ color: grey[200] }}>download</Icon>
                                    </IconButton>
                                  </Tooltip>
                                </ListItemSecondaryAction>
                              </ListItem>
                            </CardContent>
                          </Card>
                          */}
                          </div>
                        );
                      })}
                    </Else>
                  </If>
                </List>
              </Case>
              <Case value={RET_VIEW_SUBMISSION_GROUPS}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <List style={{height: 'auto', minHeight: '200px', maxHeight: '100%', overflow: 'visible', padding: '0'}}>
                      <ListItem>
                        <ListItemText>
                          <Typography variant="h6">
                            {this.props.localeData.name}
                          </Typography>
                          <Typography variant="subtitle1" style={{marginTop: '4px'}}>
                            {/* {Localization.strings.FIELD_TRIP_DATE} {this.state.currentDate.split(" ")[0]} */}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                      <Divider variant="middle"/>
                      {this.props.root.getPrivilege('AI_AUTO_ASSESSMENT').value === '1' && (
                        <ListItem style={{border:"2px solid #9e9e9e",margin:"5px 2px 5px 2px",width:"92%",left:'3.5%'}}
                          button
                          onClick={()=> {
                            this.setState({
                              selectedIndex: -1,
                              currentSubmissionId: null,
                              currentUsername: null
                            });
                            if (this.retrieverBarRef.current) {
                              this.retrieverBarRef.current.setState({ userOption: 0 });
                            }
                          }}
                          selected={this.state.selectedIndex === -1}
                        >
                          <ListItemIcon>
                            <Icon>summarize</Icon>
                          </ListItemIcon>
                          
                          <ListItemText 
                            primary={Localization.strings.SUMMARY || "查看AI總結"}
                            secondary={Localization.strings.VIEW_CLASS_SUMMARY}
                          />
                        </ListItem>
                      )}
                      
                      <Divider variant="middle" style={{marginTop: '15px', marginBottom: '5px'}}/>
                      <ListItem>
                        <ListItemText>
                          <Typography variant="subtitle1" style={{fontWeight: '500'}}>
                            {Localization.strings.INDIVIDUAL_STUDENT_SUBMISSIONS}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                      <ListItem onClick={(e) => e.stopPropagation()}>
                        <Box style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '8px', flexWrap: 'wrap' }}>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: '1 1 180px', minWidth: 0, maxWidth: 320 }} onClick={(e) => e.stopPropagation()}>
                            <Icon style={{ color: grey[600], flexShrink: 0 }}>sort</Icon>
                            <FormControl size="small" sx={{ minWidth: 0, flex: 1 }}>
                              <Select
                                value={this.state.submissionSortOption}
                                onChange={this.handleSubmissionSortChange}
                                sx={{
                                  '& .MuiSelect-select': {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  },
                                }}
                              >
                                <MenuItem value="time_desc">{Localization.strings.SUBMISSION_SORT_TIME_DESC || 'Submission Time (Latest to Earliest)'}</MenuItem>
                                <MenuItem value="time_asc">{Localization.strings.SUBMISSION_SORT_TIME_ASC || 'Submission Time (Earliest to Latest)'}</MenuItem>
                                <MenuItem value="score_desc">{Localization.strings.SUBMISSION_SORT_SCORE_DESC || 'Score (High to Low)'}</MenuItem>
                                <MenuItem value="score_asc">{Localization.strings.SUBMISSION_SORT_SCORE_ASC || 'Score (Low to High)'}</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                          <Tooltip
                            arrow
                            placement="top"
                            title={Localization.strings.VIEW_ANSWERED_QUESTIONS_TIP
                              || 'Show AI Score (answered) and Marks (answered) on each student card. These count only the questions the student answered.'}
                          >
                            <ToggleButton
                              value="answered"
                              size="small"
                              color="primary"
                              selected={this.state.showAnsweredQuestions}
                              onClick={(e) => e.stopPropagation()}
                              onChange={() => {
                                this.setState((state) => ({ showAnsweredQuestions: !state.showAnsweredQuestions }));
                              }}
                              sx={{
                                textTransform: 'none',
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                                px: 1.5,
                                lineHeight: 1.4,
                              }}
                            >
                              {Localization.strings.VIEW_ANSWERED_QUESTIONS || 'View Answered Questions'}
                            </ToggleButton>
                          </Tooltip>
                        </Box>
                      </ListItem>
                      
                      {(this.state.sortedSubmissionList.length === this.state.submissionList.length
                        ? this.state.sortedSubmissionList
                        : this.applySubmissionSort(this.state.submissionList)
                      ).map( (row, i) => {
                        const isSelected = i == this.state.selectedIndex;
                        const dateTimeStr = row['submission_time'] || '';
                        const parts = dateTimeStr.split(' ');
                        const dateText = parts[0] || '';
                        const timeText = parts[1] || '';
                        const rawScore = row['score'] !== undefined ? row['score'] : (row['score_value'] !== undefined ? row['score_value'] : null);
                        const rawMax = row['score_max'] !== undefined ? row['score_max'] : (row['max_score'] !== undefined ? row['max_score'] : null);
                        const scoreNum = rawScore !== null ? parseFloat(rawScore) : null;
                        const maxNum = rawMax !== null ? parseFloat(rawMax) : null;
                        const hideScoreRow = (scoreNum !== null && scoreNum < 0) || (maxNum !== null && maxNum < 0);

                        // The AI figure comes from the answer tree (see
                        // summariseSubmissionAnswers), NOT from row.ai_average_score:
                        // that one is only stamped during a score sort, so a marked
                        // LOCALE on the default sort would show no AI bar at all. It
                        // remains the sort key; here it is irrelevant.
                        const rawAiPercent = this.state.aiPercentBySubmissionId[row['id']];
                        const aiPercentNum = (rawAiPercent !== undefined && rawAiPercent !== null)
                          ? parseFloat(rawAiPercent)
                          : NaN;
                        const isAiPercent = !isNaN(aiPercentNum);
                        const rawAiPercentAll = this.state.aiPercentAllBySubmissionId[row['id']];
                        const aiPercentAllNum = (rawAiPercentAll !== undefined && rawAiPercentAll !== null)
                          ? parseFloat(rawAiPercentAll)
                          : NaN;
                        const isAiPercentAll = !isNaN(aiPercentAllNum);

                        // Both counters stay unknown until the answer trees land (see
                        // loadSubmissionProgress); a locale with none of a kind shows
                        // no counter for it at all.
                        const totalQuestions = this.state.totalQuestionCount;
                        const answeredQuestions = this.state.answeredCountBySubmissionId[row['id']];
                        const questionText = (totalQuestions !== null && totalQuestions > 0)
                          ? `${Localization.strings.QUESTION || 'Question'}: ${answeredQuestions === undefined ? '–' : answeredQuestions}/${totalQuestions}`
                          : null;

                        const totalHotspots = this.state.totalHotspotCount;
                        const visitedHotspots = this.state.visitedHotspotCountBySubmissionId[row['id']];
                        const hotspotText = (totalHotspots !== null && totalHotspots > 0)
                          ? `${Localization.strings.HOTSPOT || 'Hotspot'}: ${visitedHotspots === undefined ? '–' : visitedHotspots}/${totalHotspots}`
                          : null;

                        const breakdown = this.state.hotspotBreakdownBySubmissionId[row['id']];
                        const questionPercent = (totalQuestions > 0 && answeredQuestions !== undefined)
                          ? (answeredQuestions / totalQuestions) * 100
                          : 0;
                        const hotspotPercent = (totalHotspots > 0 && visitedHotspots !== undefined)
                          ? (visitedHotspots / totalHotspots) * 100
                          : 0;
                        // Marks are their OWN row now, sitting under the AI row rather
                        // than replacing it — the two answer different questions and a
                        // marked locale should show both.
                        const hasMarks = (scoreNum !== null && scoreNum >= 0 && maxNum !== null && maxNum >= 0);
                        // The list row's score/score_max is already the whole paper.
                        // Once the answer tree arrives, split it the same way as the
                        // AI bars: Marks is only the questions the student answered,
                        // Marks (all) keeps every marked question and counts a skip as 0.
                        const breakdownReady = Array.isArray(breakdown);
                        let treeEarned = 0;
                        let treeMax = 0;
                        let treeEarnedAnswered = 0;
                        let treeMaxAnswered = 0;
                        if (breakdownReady) {
                          breakdown.forEach((hotspot) => {
                            treeEarned += Number(hotspot.earned) || 0;
                            treeMax += Number(hotspot.max) || 0;
                            treeEarnedAnswered += Number(hotspot.earnedAnswered) || 0;
                            treeMaxAnswered += Number(hotspot.maxAnswered) || 0;
                          });
                        }
                        const marksAllEarned = (breakdownReady && treeMax > 0) ? treeEarned : scoreNum;
                        const marksAllMax = (breakdownReady && treeMax > 0) ? treeMax : maxNum;
                        const showMarksAll = (breakdownReady && treeMax > 0)
                          || (hasMarks && maxNum > 0);
                        const showMarksAnswered = breakdownReady && treeMaxAnswered > 0;
                        const marksAllPercent = (marksAllMax > 0) ? (marksAllEarned / marksAllMax) * 100 : 0;
                        const marksAnsweredPercent = treeMaxAnswered > 0
                          ? (treeEarnedAnswered / treeMaxAnswered) * 100
                          : 0;
                        const marksColor = this.props.theme.palette.success?.main || '#4caf50';

                        return (
                          <Card 
                            key={row['id'] || i}
                            onClick={()=>this.handleSubmissionClicked(i ,row['id'], row['user_name'])}
                            style={{
                              
                              borderRadius: '8px',
                              cursor: 'pointer',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                              margin:"10px 20px",
                              padding:"10px",
                            }}
                          >
                            <CardContent className="padding-zero" sx={{ py: 1.5, px: 2 }}>
                              {/* name | 問題 bar */}
                              <Box style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Box style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                                  <Icon>face</Icon>
                                  <Typography
                                    variant="subtitle1"
                                    style={{
                                      fontWeight: 600,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {row['user_name']}
                                  </Typography>
                                </Box>
                                {questionText && this.renderCardInlineProgress({
                                  blockKey: 'question',
                                  icon: 'help_outline',
                                  color: QUESTION_ACCENT,
                                  percent: questionPercent,
                                  tooltip: this.renderProgressTooltip(
                                    Localization.strings.QUESTION_PROGRESS_TIP
                                      || 'Questions answered, out of every question in this LOCALE',
                                    breakdown,
                                    'question',
                                    questionText
                                  ),
                                })}
                              </Box>

                              {/* time | 熱點 bar — the time keeps its row and position */}
                              <Box style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '6px' }}>
                                <Box style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <Icon style={{ color: grey[600], fontSize: '16px' }}>schedule</Icon>
                                  <Typography variant="caption" style={{ color: grey[600], whiteSpace: 'nowrap' }}>
                                    {dateText ? `${dateText} ${timeText}` : timeText}
                                  </Typography>
                                </Box>
                                {hotspotText && this.renderCardInlineProgress({
                                  blockKey: 'hotspot',
                                  icon: 'place',
                                  color: HOTSPOT_ACCENT,
                                  percent: hotspotPercent,
                                  tooltip: this.renderProgressTooltip(
                                    Localization.strings.HOTSPOT_PROGRESS_TIP
                                      || 'Hotspots with at least one answer, out of every hotspot in this LOCALE',
                                    breakdown,
                                    'hotspot',
                                    hotspotText
                                  ),
                                })}
                              </Box>

                              {/* AI assessment percentage of the questions the student answered.
                                  Drawn as a percentage, never as "(75/100)", which would
                                  read as 75 marks out of 100. Hidden unless 檢視已作答題目
                                  is on — the all-questions row below stays either way. */}
                              {this.state.showAnsweredQuestions && isAiPercent && this.renderCardProgressRow({
                                rowKey: 'ai',
                                iconNode: <SmartToyIcon style={{ color: AI_ACCENT, fontSize: '20px' }} />,
                                color: AI_ACCENT,
                                labelColor: AI_ACCENT,
                                percent: aiPercentNum,
                                label: `${Localization.strings.AI_SCORE_ANSWERED || 'AI Score (answered)'}: ${Math.round(aiPercentNum * 100) / 100}%`,
                                tooltip: this.renderProgressTooltip(
                                  Localization.strings.AI_PERCENT_TIP
                                    || 'Average of this student\'s AI assessment percentages on the questions they answered — a percentage, not marks out of a maximum',
                                  // Now that the average is scraped from this very tree,
                                  // a per-hotspot breakdown reconciles with it exactly.
                                  breakdown,
                                  'ai'
                                ),
                              })}

                              {/* Same percentage, taken over every question AI can assess.
                                  Unanswered questions count as 0%, so a student who skipped
                                  half the paper scores about half of the row above. */}
                              {isAiPercentAll && this.renderCardProgressRow({
                                rowKey: 'aiAll',
                                iconNode: <SmartToyIcon style={{ color: AI_ALL_ACCENT, fontSize: '20px' }} />,
                                color: AI_ALL_ACCENT,
                                labelColor: AI_ALL_ACCENT,
                                percent: aiPercentAllNum,
                                label: `${Localization.strings.AI_SCORE_ALL || 'AI Score (all)'}: ${Math.round(aiPercentAllNum * 100) / 100}%`,
                                tooltip: this.renderProgressTooltip(
                                  Localization.strings.AI_PERCENT_ALL_TIP
                                    || 'Average across every question in this LOCALE that AI can assess. A question the student did not answer counts as 0% — a percentage, not marks out of a maximum',
                                  breakdown,
                                  'aiAll'
                                ),
                              })}

                              {/* Points on the questions the student actually answered. Hidden
                                  until the answer tree can say which those were, and until
                                  檢視已作答題目 is on. */}
                              {this.state.showAnsweredQuestions && showMarksAnswered && this.renderCardProgressRow({
                                rowKey: 'marks',
                                icon: 'emoji_events',
                                color: MARKS_ANSWERED_ACCENT,
                                percent: marksAnsweredPercent,
                                label: `${Localization.strings.MARKS_ANSWERED || 'Marks (answered)'}: ${formatMark(treeEarnedAnswered)}/${formatMark(treeMaxAnswered)}`,
                                tooltip: this.renderProgressTooltip(
                                  Localization.strings.SCORE_MARKS_ANSWERED_TIP
                                    || 'Marks earned on the questions this student answered, out of the marks those questions are worth',
                                  breakdown,
                                  'earnedAnswered'
                                ),
                              })}

                              {/* The whole paper. This is the score/score_max the list
                                  already carried; a skipped question counts as 0. */}
                              {showMarksAll && this.renderCardProgressRow({
                                rowKey: 'marksAll',
                                icon: 'emoji_events',
                                color: marksColor,
                                percent: marksAllPercent,
                                label: `${Localization.strings.MARKS_ALL || 'Marks (all)'}: ${formatMark(marksAllEarned)}/${formatMark(marksAllMax)}`,
                                tooltip: this.renderProgressTooltip(
                                  Localization.strings.SCORE_MARKS_ALL_TIP
                                    || 'Marks earned out of every marked question in this LOCALE. A question the student did not answer counts as 0',
                                  breakdown,
                                  'earned'
                                ),
                              })}

                              {/* No marks to draw at all — say which of the two reasons,
                                  rather than leaving a blank where a bar would be. */}
                              {!showMarksAll && !showMarksAnswered && hideScoreRow && (() => {
                                const localeUnmarked = (maxNum !== null && maxNum < 0);
                                const heading = localeUnmarked
                                  ? (Localization.strings.SCORE_NOT_SET_TIP
                                      || 'No question in this LOCALE has marks assigned, so there is no score')
                                  : (Localization.strings.SCORE_PENDING_TIP
                                      || 'This LOCALE is marked, but none of this student\'s answers has a score yet');
                                return (
                                  <Tooltip
                                    arrow
                                    placement="left"
                                    title={this.renderProgressTooltip(
                                      heading,
                                      breakdown,
                                      localeUnmarked ? 'marks' : 'question'
                                    )}
                                  >
                                    <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
                                      <Icon style={{ color: grey[500], fontSize: '20px' }}>emoji_events</Icon>
                                      <Typography variant="body2" style={{ color: grey[600], ...HOVERABLE_COUNTER_STYLE }}>
                                        {localeUnmarked
                                          ? (Localization.strings.SCORE_NOT_SET || 'Not marked')
                                          : (Localization.strings.SCORE_PENDING || 'Not marked yet')}
                                      </Typography>
                                    </Box>
                                  </Tooltip>
                                );
                              })()}
                            </CardContent>
                          </Card>
                        );
                      })}
                    </List>
                  </Grid>
                </Grid>
              </Case>
            </Switch>
          </Grid>
          <Grid item xs={8} sm={9} sx={{ pr: 3 }}>
            {this.state.status === RET_VIEW_SUBMISSION_GROUPS && (
              <>
                {this.state.selectedIndex === -1 ? (
                  <div style={{paddingTop: '48px', marginRight: '24px'}}>
                                          { this.props.root.getPrivilege('AI_AUTO_ASSESSMENT').value === '1' ? (
                        <AIAssessmentPage 
                          isAIProgressNotification={this.props.root.getPrivilege('AI_PROGRESS_NOTI').value === '1'}
                          epackName={this.props.localeData.name}
                          submissionDate={this.state.showAllDates ? this.state.currentDate : (this.state.actualFilterDate || this.state.dateFilterStart)}
                          dateFilterStart={this.state.dateFilterStart}
                          dateFilterEnd={this.state.dateFilterEnd}
                          isDateRangeFilter={!this.state.showAllDates && (this.state.dateFilterStart || this.state.dateFilterEnd)}
                          selectedDates={this.state.selectedDates}
                          submissionList={this.state.submissionList}
                          submissionProgressById={this.state.submissionProgressById}
                          onSelectStudent={this.handleStudentNameClicked}
                          hasSubmissions={this.state.submissionGroupList.length > 0}
                          root={this.props.root}
                          localeId={this.state.currentLocaleId}
                          schoolId={this.props.root.getMySchoolId()}
                          canExportAnswers={this.props.root.getPrivilege('ANSWER_EXPORT').value === '1'}
                          onExportAllAnswers={() => this.handleExportAllAnswers()}
                          onExportAiScores={() => this.handleExportAiScores()}
                          onExportMarks={() => this.handleExportMarks()}
                          isManualAIAssessment={parseInt(this.props.localeData.is_manual_ai_assessment, 10) === 1}
                          canManageLocale={this.canManageLocale()}
                          tempDateFilterStart={this.state.tempDateFilterStart}
                          tempDateFilterEnd={this.state.tempDateFilterEnd}
                          onDateFilterStartChange={(value) => this.handleDateFilterStart(value)}
                          onDateFilterEndChange={(value) => this.handleDateFilterEnd(value)}
                          onConfirmDateFilter={() => this.handleConfirmDateFilter()}
                          onClearDateFilter={() => this.handleClearDateFilter()}
                        />
                      ) : (
                        <OverallAssessmentPage
                          epackName={this.props.localeData.name}
                          submissionDate={this.state.showAllDates ? this.state.currentDate : (this.state.actualFilterDate || this.state.dateFilterStart)}
                          dateFilterStart={this.state.dateFilterStart}
                          dateFilterEnd={this.state.dateFilterEnd}
                          isDateRangeFilter={!this.state.showAllDates && (this.state.dateFilterStart || this.state.dateFilterEnd)}
                          selectedDates={this.state.selectedDates}
                          submissionList={this.state.submissionList}
                          hasSubmissions={this.state.submissionGroupList.length > 0}
                          root={this.props.root}
                          localeId={this.state.currentLocaleId}
                          schoolId={this.props.root.getMySchoolId()}
                          tempDateFilterStart={this.state.tempDateFilterStart}
                          tempDateFilterEnd={this.state.tempDateFilterEnd}
                          onDateFilterStartChange={(value) => this.handleDateFilterStart(value)}
                          onDateFilterEndChange={(value) => this.handleDateFilterEnd(value)}
                          onConfirmDateFilter={() => this.handleConfirmDateFilter()}
                          onClearDateFilter={() => this.handleClearDateFilter()}
                        />
                      )
                    }
                  </div>
                ) : (
                  <div style={{paddingTop: '12px', marginRight: '24px'}}>
                    <SubmissionDetail
                      ref={this.submissionDetailRef}
                      parent={this}
                      root={this.props.root}
                    />
                  </div>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withTheme(RetrieverPage);
